(function () {
    'use strict';
    var controllerId = 'cndAccreditamento';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', 'common', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', '_', cndAccreditamento]);

    function cndAccreditamento($scope, $rootScope, common, bDialog, $routeParams, modal, datacontext, sectionMenu, filterFilter, _) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');


        var vm = this;
        vm.title = 'Accreditamento';
        vm.view = 'detail';       //Mettendo 'detail' si elimina l'errore del $compile: ctreq
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "accreditamento"; //Utilizzato per pannello authorization		
        vm.authorization = {};
        vm.tSourceCode_ACCR = "ACCR";
        vm.tSourceCode_ADES = "ADES";
        vm.isVisibleLinkDomanda = false;
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.maxStep = 4;
        vm.maxAdesioni = 2;
        vm.iFinestra = 3; //TERZA FINESTRA
        vm.actualAdesione = 0;
        vm.index = 0;
        vm.custom = false;
        vm.showInfoMsg = true;
        vm.setShowInfoMsg = setShowInfoMsg;
        vm.ableMenu = true;
        vm.PdfReady = true;
        vm.classStep = [];
        vm.classStepIcon = [];
        vm.classStepComplete = [];
        vm.stepEdit = [];
        vm.stepCompleted = [];
        vm.myPristine = false;
        vm.isClickDay = false;
        vm.nrMesiTrc = 0;
        vm.errorAccess = '';
        vm.showToggle = true;

        //Pannelli dei dati (viewAccred)
        vm.showPanelAccred1 = true;
        vm.showPanelAccred2 = true;
        vm.showPanelAccred3 = true;
        vm.showPanelAccred4 = true;
        vm.setShowPanelAccred1 = setShowPanelAccred1;
        vm.setShowPanelAccred2 = setShowPanelAccred2;
        vm.setShowPanelAccred3 = setShowPanelAccred3;
        vm.setShowPanelAccred4 = setShowPanelAccred4;

        //Pannelli dei dati (viewAdes)
        vm.showPanelAdes1 = true;
        vm.showPanelAdes2 = true;
        vm.showPanelAdes3 = true;
        vm.showPanelAdes4 = true;
        vm.setShowPanelAdes1 = setShowPanelAdes1;
        vm.setShowPanelAdes2 = setShowPanelAdes2;
        vm.setShowPanelAdes3 = setShowPanelAdes3;
        vm.setShowPanelAdes4 = setShowPanelAdes4;

        //Pannelli dei dati (viewAtt)
        vm.showPanelAtt1 = true;
        vm.showPanelAtt2 = true;
        vm.showPanelAtt3 = true;
        vm.setShowPanelAtt1 = setShowPanelAtt1;
        vm.setShowPanelAtt2 = setShowPanelAtt2;
        vm.setShowPanelAtt3 = setShowPanelAtt3;

        //Pannelli dei dati (viewRiep)
        vm.showPanelRiep1 = true;
        vm.setShowPanelRiep1 = setShowPanelRiep1;

        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.saving = false;

        vm.cndProgetto = {};
        vm.adesione = {};
        vm.urlRoot = datacontext.accreditamento_getURL();

        vm.testing = true;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Ragione Sociale', 'Codice Fiscale', 'Cod Ateco', 'Forma Giuridica'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        //Elenchi dettaglio
        vm.list.attach = [];

        vm.list.b_attach = false;

        vm.list.cndAccreditamentiSedi = [];

        vm.getAllCNDAccreditamentiSedi = getAllCNDAccreditamentiSedi;
        vm.addCNDAccreditamentoSede = addCNDAccreditamentoSede;
        vm.editCNDAccreditamentoSede = editCNDAccreditamentoSede;
        vm.deleteCNDAccreditamentoSede = deleteCNDAccreditamentoSede;

        vm.deleteTir = deleteAdes;



        //Attach 2
        vm.tAttach_Needed = [];
        vm.tAttach_ACCR = [];
        vm.tAttach_ADES = [];
        vm.list.attach_accr = [];
        vm.list.attach_tir1 = [];
        vm.list.attach_tir2 = [];
        vm.addAttach = addAttach;
        vm.getListAttach = getListAttach;
        vm.deleteAttach = deleteAttach;
        vm.extractCADESFile = getExtractCADESFile;
        vm.extractVerifySignInfo = getExtractVerifySignInfo;

        vm.populateAttach = populateAttach;


        vm.resetComuni = resetComuni;

        //Conteggio Elenchi
        vm.countAttachProfilo = function () {
            var filter = {};
            return filterFilter(vm.list.attach, filter).length;
        };


        //Filtro
        vm.fAttach = {};
        vm.setfAttach = setfAttach;

        //Elenchi per filtri e finestra modale di Create
        vm.province = [];
        vm.provinceSicilia = [];
        vm.comuni = [];
        vm.tSource = {};
        vm.tAttach = [];
        vm.lstFormaGiuridica = [];
        vm.lstAteco = [];
        //per anagrafica rappresentante LEGALE
        vm.provinceNasc_L = [];
        vm.comuniNasc_L = [];
        vm.paesiNasc_L = [];

        vm.cmblist = {};
        vm.cmblist.tir_nasc_paesi = [];
        vm.cmblist.tir_nasc_province = [];
        vm.cmblist.tir_nasc_comuni = [];

        vm.cmblist.tir_res_province = [];
        vm.cmblist.tir_res_comuni = [];
        vm.cmblist.tir_res_paesi = [];

        vm.cmblist.res_province = [];
        vm.cmblist.res_comuni = [];
        vm.cmblist.res_paesi = [];

        vm.cmblist.dom_province = [];
        vm.cmblist.dom_comuni = [];
        vm.cmblist.dom_paesi = [];

        vm.cmblist.tir_dom_province = [];
        vm.cmblist.tir_dom_comuni = [];
        vm.cmblist.tir_dom_paesi = [];

        vm.cmblist.tir_sede_province = [];
        vm.cmblist.tir_sede_comuni = [];

        vm.cmblist.cittadinanze = [];

        vm.cmblist.sedeOp_comuni = [];
        vm.cmblist.sedeOp_province = [];

        vm.cmblist.titoliStudio = [];

        vm.cmblist.trcObbl_comuni = [];
        vm.cmblist.trcObbl_province = [];

        vm.cmblist.ateco = [];

        vm.reset_PaeseNascTir = reset_PaeseNascTir;
        vm.resetComuni_NascTir = resetComuni_NascTir;
        vm.reset_PaeseResTir = reset_PaeseResTir;
        vm.resetComuni_ResTir = resetComuni_ResTir;
        vm.reset_PaeseDomTir = reset_PaeseDomTir;
        vm.resetComuni_DomTir = resetComuni_DomTir;
        vm.resetComuni_SedeTir = resetComuni_SedeTir;

        vm.resetComuniNasc = resetComuniNasc;
        vm.reset_PaeseNasc = reset_PaeseNasc;
        vm.reset_PaeseRes = reset_PaeseRes;
        vm.resetComuni_Res = resetComuni_Res;
        vm.reset_PaeseDom = reset_PaeseDom;
        vm.resetComuni_Dom = resetComuni_Dom;

        vm.resetComuni_SedeOp = resetComuni_SedeOp;
        vm.resetComuni_TrcObbl = resetComuni_TrcObbl;
        vm.setComuneTrcObbl = setComuneTrcObbl;
        vm.reset_TrcObbl = reset_TrcObbl;
        vm.reset_Azienda = reset_Azienda;
        vm.reset_SedeOperativa = reset_SedeOperativa;

        vm.reset_DomUgualeRes = reset_DomUgualeRes;
        vm.reset_DomUgualeResTir = reset_DomUgualeResTir;

        vm.reset_AllC = reset_AllC;
        vm.reset_TrcAvviato = reset_TrcAvviato;


        vm.setFieldsResTir = setFieldsResTir;
        vm.tir_maxLenResCAP = 5;



        //Metodi su interfaccia
        vm.activated = false;

        //Tirocinio
        vm.getNrMesiTrc = getNrMesiTrc;
        vm.validDate = true;
        vm.getValidDate = getValidDate;
        //var minDateStart = moment('09-17-2018', "MM-DD-YYYY");//Data minima di Avvio Tirocinio
        var maxDateStart = moment('03-29-2019', "MM-DD-YYYY"); //Data massima di Avvio Tirocinio
        //var minDateEnd = minDateStart; //Data minima di Fine Tirocinio
        var maxDateEnd = moment('03-29-2019', "MM-DD-YYYY").add(24, 'month'); //Data massima di Fine Tirocinio
        //Intervallo DtStartPrevTRC
        //$scope.minDateStartTrc = minDateStart.format();
        $scope.maxDateStartTrc = maxDateStart.format();
        //Intervallo DtEndPrevTRC
        //$scope.minDateEndTrc = minDateEnd.format();
        $scope.maxDateEndTrc = maxDateEnd.format();

        //vm.addAttach = addAttach;
        //vm.deleteAttach = deleteAttach;
        vm.setCompleted = setCompleted;
        vm.setSent = setSent;
        vm.unlock = unlockItem;
        vm.setAttachChecked = setAttachChecked;

        //Gestione conferma input di tipo Email
        vm.confirm = {};
        //vm.getConfirmEMAIL = getConfirmEMAIL;
        //vm.validEmail = true;
        //vm.validPEC = true;
        //vm.validDichPEC = true;

        //vm.get = getRecord;
        //vm.update = saveOrUpdateItem;
        vm.saveAccred = saveOrUpdateAccred;
        vm.saveAdes = saveOrUpdateAdes;
        vm.addTir = addAdesione;
        vm.nextTir = nextAdesione;
        vm.prevTir = prevAdesione;
        vm.delete = deleteItem;

        vm.pubblico_click = pubblico_click;
        vm.bSuspended_click = bSuspended_click;

        vm.prevStep = prevStep;
        vm.nextStep = nextStep;

        vm.isVisiblePrevButton = isVisiblePrevButton;
        vm.isVisibleNextButton = isVisibleNextButton;
        vm.isVisibleSaveButton = isVisibleSaveButton;
        vm.isAbleTirAdd = isAbleTirAdd;
        vm.isAbleTirDelete = isAbleTirDelete;
        vm.isVisibleTirNext = isVisibleTirNext;
        vm.isVisibleTirPrev = isVisibleTirPrev;


        vm.isAblePrevButton = isAblePrevButton;
        vm.isAbleNextButton = isAbleNextButton;
        vm.isAbleSaveButton = isAbleSaveButton;
        vm.isAbleAddButton = isAbleAddButton;
        vm.isAbleTirPrev = isAbleTirPrev;
        vm.isAbleTirNext = isAbleTirNext



        vm.printAllA = printAllA;
        vm.setStep = setStep;
        vm.printAllB = printAllB;
        vm.printAllC = printAllC;



        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;
            vm.opened3 = false;
            vm.opened4 = false;
            vm.opened5 = false;
            vm.opened6 = false;
            if (iOpened == 1) vm.opened1 = true;
            else if (iOpened == 2) vm.opened2 = true;
            else if (iOpened == 3) vm.opened3 = true;
            else if (iOpened == 4) vm.opened4 = true;
            else if (iOpened == 5) vm.opened5 = true;
            else if (iOpened == 6) vm.opened6 = true;
        };

        vm.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                vm.record.L_DtNasc = '';
                vm.changed = true;
            }
            else if (iOpened == 3) {
                vm.adesione.NascData = '';
                vm.changed = true;
            }
            else if (iOpened == 4) {
                vm.adesione.TrcObbl_DtIscrizione = '';
                vm.changed = true;
            }
            else if (iOpened == 5) {
                vm.adesione.Trc_DtStartPrev = '';
                vm.changed = true;
                vm.nrMesiTrc = 0;
                vm.validDate = true;
            }
            else if (iOpened == 6) {
                vm.adesione.Trc_DtEndPrev = '';
                vm.changed = true;
                vm.nrMesiTrc = 0;
                vm.validDate = true;
            }
        };

        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        // ---- ACTIVATE -------
        loadStepParams();
        activate();
        /*
        vm.changeForm = false;
        vm.resetForm = resetForm;
        function resetForm() {
            console.log('resetForm');
            //$("input").each(function (elem) {
            $('input[ng-model]').each(function () {
                //elem.$pristine = true;
                console.info('resetForm', this);
            });


            var form = $('form#viewAdes'),
                formScope = form.next('div').scope(),
                classes, x, L;

            console.info('resetForm', form, formScope);
            formScope.viewAdes.$error = {};
            formScope.viewAdes.$pristine = true;
            formScope.viewAdes.$dirty = false;
            formScope.viewAdes.$valid = true;
            formScope.viewAdes.$invalid = false;
            classes = form.get()[0].classList;
            for (x = 0, L = classes.length; x < L; x++) {
                if (classes[x] == null) continue;
                if (classes[x].indexOf('ng-') == 0 && classes[x] != 'ng-scope') {
                    form.removeClass(classes[x]);
                }
            }

        }
        */



        function activate() {
            if ($routeParams.projectUID != null) {
                return getCNDProgetto($routeParams.projectUID).then(function () {
                    if ($routeParams.accreditamentoUID != null) {
                        return getRecordByUID($routeParams.accreditamentoUID).then(function () {
                            if (!vm.record.Completed) {
                                var promises = [getTSourceACCR(), getTSourceADES(), getTAttach(vm.tSourceCode_ACCR), getTAttachNeededAccr(), getTAttachNeededAdes(), getTitoliStudio(), getPaesi_Nasc(), getProvince_Nasc(), getPaesi_NascTir(), getProvince_NascTir(), getProvince_TrcObbl(), getProvince(), getPaesi_Res(), getProvince_Res(), getPaesi_Dom(), getProvince_Dom(), getPaesi_ResTir(), getProvince_ResTir(), getPaesi_DomTir(), getProvince_DomTir(), getProvince_SedeTir(), getProvince_SedeOp(), getCittadinanze(), getTAteco()];
                                return common.activateController(promises, controllerId)
                                    .then(function () {
                                        return true;
                                    });
                            }
                            else if (!vm.record.attachChecked) {
                                var promises1 = [getTSourceACCR(), getTSourceADES(), getTAttach(vm.tSourceCode_ACCR), getTAttachNeededAccr(), getTAttachNeededAdes()];
                                return common.activateController(promises1, controllerId)
                                    .then(function () {
                                        return true;
                                    });
                            }
                        });
                    }
                    else {
                        vm.record.Id = 0;
                        vm.record.L_PaeseNascId = 0;
                        vm.record.L_ResPaeseId = 0;
                        vm.record.L_DomPaeseId = 0;
                        vm.record.L_CittadinanzaId = 0;
                        vm.confirm.L_Email = '';
                        vm.confirm.Email = '';
                        vm.confirm.PEC = '';
                        vm.confirm.Dich_PEC = '';

                        var promises = [getTSourceACCR(), getTSourceADES(), getTAttach(vm.tSourceCode_ACCR), getTitoliStudio(), getTAttachNeededAccr(), getTAttachNeededAdes(), getPaesi_Nasc(), getProvince_Nasc(), getPaesi_NascTir(), getProvince_NascTir(), getProvince_TrcObbl(), getProvince(), getPaesi_Res(), getProvince_Res(), getPaesi_Dom(), getProvince_Dom(), getPaesi_ResTir(), getProvince_ResTir(), getPaesi_DomTir(), getProvince_DomTir(), getProvince_SedeTir(), getProvince_SedeOp(), getCittadinanze(), getTAteco()];
                        return common.activateController(promises, controllerId)
                            .then(function () {
                                return setStep(0);
                            });
                    }

                    //vm.sectionMenu = sectionMenu.setSection(vm.title);
                    //vm.activated = true;
                    //sectionMenu.setProjectUId($routeParams.projectUID);
                });

            }
        }


        //****************************************************
        // METODI GESTIONE VIEW
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function nextStep() {
            bDialog.confirmationDialog('Attenzione', 'Si sta passando alla Fase successiva, se le modifiche non sono state salvate, verrano perse. Procedere? ', 'Ok').then(
                function () { //YES
                    setStep(vm.actualStep + 1);
                },
                function () { //NO
                    //
                }
            );
        }

        function addAdesione() {
            bDialog.confirmationDialog('Attenzione', 'Si sta aggiungendo un nuovo tirocinante, se le modifiche non sono state salvate, verrano perse. Procedere? ', 'Ok').then(
                function () { //YES
                    vm.actualAdesione = vm.actualAdesione + 1;
                    //vm.record.Adesioni[vm.actualAdesione].Id = 0;
                    getAdesione(0);
                    setStep(vm.actualStep);
                },
                function () { //NO
                    //
                }
            );
        }

        function nextAdesione() {
            bDialog.confirmationDialog('Attenzione', 'Si sta passando al tirocinio successivo, se le modifiche non sono state salvate, verrano perse. Procedere? ', 'Ok').then(
                function () { //YES
                    vm.actualAdesione = vm.actualAdesione + 1;
                    getAdesione(vm.record.Adesioni[vm.actualAdesione].Id);
                    setStep(vm.actualStep);
                },
                function () { //NO
                    //
                }
            );
        }

        function prevAdesione() {
            bDialog.confirmationDialog('Attenzione', 'Si sta passando al tirocinio precedente, se le modifiche non sono state salvate, verrano perse. Procedere? ', 'Ok').then(
                function () { //YES
                    vm.actualAdesione = vm.actualAdesione - 1;
                    getAdesione(vm.record.Adesioni[vm.actualAdesione].Id);
                    setStep(vm.actualStep);
                },
                function () { //NO
                    //
                }
            );
        }

        function prevStep() {
            setStep(vm.actualStep - 1);
        }

        function loadStepParams() {
            vm.labelsStep = [];
            vm.titlesStep = [];
            vm.subtitlesStep = [];
            vm.descriptionsStep = [];

            vm.labelsStep[0] = "A";
            vm.titlesStep[0] = "Fase A";
            vm.subtitlesStep[0] = "Domanda di partecipazione";
            vm.descriptionsStep[0] = "In questa prima fase &egrave; richiesto l'inserimento dei dati necessari alla compilazione della 'Domanda di partecipazione' (Allegato A).<br/>&Egrave; possibile procedere alla fase successiva solo dopo aver inserito e salvato tutte le informazioni richieste in questa fase.";

            vm.labelsStep[1] = "B";
            vm.titlesStep[1] = "Fase B";
            vm.subtitlesStep[1] = "Dichiarazione tirocinante";
            vm.descriptionsStep[1] = "In questa fase &egrave; richiesto l'inserimento dei dati necessari alla compilazione del 'Modulo di adesione del tirocinante' (Allegato B) e, se del caso, della 'Scheda del Progetto Formativo' (Allegato C).<br/>Per aggiungere l'eventuale secondo tirocinante utilizzare il pulsante 'Aggiungi Tirocinante'; per navigare tra i tirocinanti utilizzare il pulsante 'Scheda tirocinante'.";

            vm.labelsStep[2] = "C";
            vm.titlesStep[2] = "Fase C";
            vm.subtitlesStep[2] = "Upload Documentale";
            vm.descriptionsStep[2] = "In questa fase occore scaricare gli allegati A, B, C (nel caso ci sia) generati dal portale, firmarli (l'allegato A va firmato digitalmente) e ricaricarli unitamente all'altra documentazione richiesta, compilando integralmente l'elenco.";

            vm.labelsStep[3] = "D";
            vm.titlesStep[3] = "Fase D";
            vm.subtitlesStep[3] = "Stampa ricevuta";
            vm.descriptionsStep[3] = "In questa fase &egrave possibile stampare la 'Ricevuta di adesione' che contiene il numero di istanza da riportare nell'oggetto della PEC e da allegare nella stessa.";
        }

        function setStepDefault() {
            if (vm.record.attachChecked) {
                setStep(3);
            } else if (vm.record.Completed) {
                setStep(2);
            } else if (vm.record != undefined && vm.record.Adesioni != undefined && vm.record.Adesioni.length > 0) {
                setStep(1);
            } else {
                setStep(0);
            }
        }

        function setStep(actualStep) {

            if (actualStep >= vm.maxStep)
                actualStep = vm.maxStep - 1;

            if (actualStep < 0)
                actualStep = 0;

            vm.actualStep = actualStep;
            vm.subStep = "";
            switch (vm.actualStep) {
                case 0:
                    setView('viewAccred');
                    vm.actualAdesione = 0;
                    break;
                case 1:
                    //vm.actualAdesione = 0; //TODO
                    var iTir = vm.actualAdesione + 1;
                    if (vm.record != undefined && vm.record.Adesioni != undefined && vm.record.Adesioni.length > 0) {
                        var nTir = vm.record.Adesioni.length;
                        if (nTir < iTir) nTir = iTir;
                        vm.subStep = "Scheda Tirocinante: " + iTir + " / " + nTir;
                    }
                    var adesioneId = 0;
                    if (vm.record != undefined && vm.record.Adesioni != undefined && vm.record.Adesioni[vm.actualAdesione] != undefined && vm.record.Adesioni[vm.actualAdesione].Id != undefined)
                        adesioneId = vm.record.Adesioni[vm.actualAdesione].Id;
                    getAdesione(adesioneId);
                    setView('viewAdes');
                    break;
                case 2:
                    vm.actualAdesione = 0;
                    populateAttach();
                    setView('viewAtt');
                    break;
                case 3:
                    vm.actualAdesione = 0;
                    setView('viewRiep');

                    break;
            }

            vm.labelStep = vm.labelsStep[vm.actualStep];
            vm.titleStep = vm.titlesStep[vm.actualStep];
            vm.subtitleStep = vm.subtitlesStep[vm.actualStep];
            vm.descriptionStep = vm.descriptionsStep[vm.actualStep];
            setClassSeqWiz();

        }


        function setClassSeqWiz() {
            vm.classStep = [];
            vm.classStepIcon = [];
            vm.classStepComplete = [];
            vm.stepEdit = [];
            vm.stepCompleted = [];


            var cssEdit = 'blue';
            var cssCompleted = 'green';
            var cssDefault = 'gray';
            var cssLast = 'last';

            var faIconEdit = 'fa fa-pencil';
            var faIconComplete = 'fa fa-check';
            var faIconDefault = '';

            var cssStepComplete = 'step-complete';

            var spanEdit = 'span-select';
            var spanDefault = '';

            vm.stepEdit[vm.actualStep] = true;
            vm.stepCompleted[0] = (vm.record != undefined && vm.record.Completed);
            vm.stepCompleted[1] = (vm.record != undefined && vm.record.Completed);
            vm.stepCompleted[2] = (vm.record != undefined && vm.record.attachChecked);
            vm.stepCompleted[3] = (vm.record != undefined && vm.record.Sent);

            for (var i = 0; i < vm.maxStep; i++) {

                //Seconda Gestione
                //CLASS STEP
                vm.classStep[i] = '';
                if (vm.stepEdit[i]) // se � in edit
                    vm.classStep[i] = cssEdit;
                else // altrimenti
                    vm.classStep[i] = cssDefault;

                if (i + 1 == vm.maxStep) // se sono nell'ultima fase
                    vm.classStep[i] = cssLast + '-' + vm.classStep[i];
                else if (vm.stepEdit[i + 1]) // se � in edit
                    vm.classStep[i] = vm.classStep[i] + '-' + cssEdit;
                else // altrimenti
                    vm.classStep[i] = vm.classStep[i] + '-' + cssDefault;


                //ICON STEP
                vm.classStepIcon[i] = '';
                if (vm.stepCompleted[i]) // se � completed
                    vm.classStepIcon[i] = faIconComplete;
                else if (vm.stepEdit[i]) // se � in edit
                    vm.classStepIcon[i] = faIconEdit;

                //ICON STEP COMPLETE
                vm.classStepComplete[i] = '';
                if (vm.stepCompleted[i] && !vm.stepEdit[i]) // se � completed
                    vm.classStepComplete[i] = cssStepComplete;

                //console.log('setClassSeqWiz', i, vm.maxStep, vm.classStep[i], vm.classStepIcon[i], vm.spanStep[i]);

                /*
                //Prima Gestione
                if (vm.stepEdit[i]) // se � in edit
                    vm.classStep[i] = cssEdit;
                else if (vm.stepCompleted[i]) // se � completato
                    vm.classStep[i] = cssCompleted;
                else // altrimenti
                    vm.classStep[i] = cssDefault;
                

                if (vm.stepEdit[i+1]) // se � in edit
                    vm.classStep[i] = vm.classStep[i] + '-' + cssEdit;
                else if (vm.stepCompleted[i+1]) // se � completato
                    vm.classStep[i] = vm.classStep[i] + '-' + cssCompleted;
                else // altrimenti
                    vm.classStep[i] = vm.classStep[i] + '-' + cssDefault;
                */
            }
        }

        function isAblePrevButton() {
            //Inserire qui i casi in cui non � abilitata la fase successiva
            return vm.actualStep > 0;
        }
        function isAbleNextButton() {
            var able = false;
            //Inserire qui i casi in cui non � abilitata la fase successiva
            switch (vm.view) {
                case 'viewAccred':
                    if (vm.record.Id > 0)
                        able = true;
                    break;
                case 'viewAdes':
                    if (vm.record.Adesioni != undefined && vm.record.Adesioni[0] != undefined && vm.record.Adesioni[0].Id > 0)
                        able = true;
                    break;
                case 'viewAtt':
                    if (vm.record != undefined && vm.record.Completed)
                        able = true;
                    break;
            }

            return vm.actualStep < (vm.maxStep - 1) && able;
        }

        function isAbleSaveButton() {
            var disable = false;

            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.saving, form);
            //disable = form.$pristine || form.$invalid || vm.saving;
            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    disable = vm.saving || vm.record.Completed
                        || (vm.record.PEC != undefined && vm.record.PEC.toLowerCase() != vm.confirm.PEC.toLowerCase())
                        || (vm.record.Email != undefined && vm.record.Email.toLowerCase() != vm.confirm.Email.toLowerCase())
                        || (vm.record.Dich_PEC != undefined && vm.record.Dich_PEC.toLowerCase() != vm.confirm.Dich_PEC.toLowerCase())
                        || (vm.record.L_Email != undefined && vm.record.L_Email.toLowerCase() != vm.confirm.L_Email.toLowerCase());
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    disable = vm.saving || vm.adesione.Completed
                        || (vm.adesione.PEC != undefined && vm.confirm.TirPEC != undefined && vm.adesione.PEC.toLowerCase() != vm.confirm.TirPEC.toLowerCase())
                        || (vm.adesione.Email != undefined && vm.confirm.TirEmail != undefined && vm.adesione.Email.toLowerCase() != vm.confirm.TirEmail.toLowerCase());
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
                case 3:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
            }

            return !disable;
        }
        function isAbleAddButton() {
            var disable = false;
            var form = document.forms[vm.view];
            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.saving, form);
            //disable = form.$pristine || form.$invalid

            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 3:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 4:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
            }

            return !disable;
        }

        function isAbleTirPrev() {
            return vm.actualAdesione > 0;
        }
        function isAbleTirNext() {
            var maxAdesioni = 0;
            if (vm.record != undefined && vm.record.Adesioni != undefined)
                maxAdesioni = vm.record.Adesioni.length;
            //if (maxAdesioni > vm.maxAdesioni) maxAdesioni = vm.maxAdesioni;
            return vm.actualAdesione < (maxAdesioni - 1);
        }

        function isVisiblePrevButton() {
            return true;
        }
        function isVisibleNextButton() {
            return true;
        }
        function isVisibleSaveButton() {
            return true;
        }

        function isVisibleTirNext() {
            var maxAdesioni = 0;
            if (vm.record != undefined && vm.record.Adesioni != undefined)
                maxAdesioni = vm.record.Adesioni.length;
            //if (maxAdesioni > vm.maxAdesioni) maxAdesioni = vm.maxAdesioni;
            return vm.actualAdesione < (maxAdesioni - 1);

        }
        function isVisibleTirPrev() {
            return vm.actualAdesione > 0;
            //return !isVisibleTirNext() && !isVisibleTirAdd();
        }
        function isAbleTirAdd() {
            var retVal = (vm.adesione != undefined && vm.adesione.Id != '' && vm.adesione.Id != 0 && vm.record != undefined && vm.record.Adesioni != undefined && vm.record.Adesioni.length) < vm.maxAdesioni && vm.actualAdesione < (vm.maxAdesioni - 1) && !isVisibleTirNext() && !vm.adesione.Completed && !vm.record.Sent;
            return retVal;
        }
        function isAbleTirDelete() {
            var retVal = vm.adesione != undefined && vm.adesione.Id != '' && vm.adesione.Id != 0 && vm.record.Adesioni != undefined && vm.record.Adesioni[vm.actualAdesione] != undefined && vm.record.Adesioni[vm.actualAdesione].Id == vm.adesione.Id && !vm.adesione.Completed && !vm.record.Sent;
            return retVal;
        }

        function isVisibleAddButton() {
            return true;
        }

        function setShowInfoMsg() {
            return vm.showInfoMsg = !vm.showInfoMsg;
        }

        //Gestione per viewAccred
        function setShowPanelAccred1() {
            return vm.showPanelAccred1 = !vm.showPanelAccred1;
        }
        function setShowPanelAccred2() {
            return vm.showPanelAccred2 = !vm.showPanelAccred2;
        }
        function setShowPanelAccred3() {
            return vm.showPanelAccred3 = !vm.showPanelAccred3;
        }
        function setShowPanelAccred4() {
            return vm.showPanelAccred4 = !vm.showPanelAccred4;
        }

        //Gestione per viewAdes
        function setShowPanelAdes1() {
            return vm.showPanelAdes1 = !vm.showPanelAdes1;
        }
        function setShowPanelAdes2() {
            return vm.showPanelAdes2 = !vm.showPanelAdes2;
        }
        function setShowPanelAdes3() {
            return vm.showPanelAdes3 = !vm.showPanelAdes3;
        }
        function setShowPanelAdes4() {
            return vm.showPanelAdes4 = !vm.showPanelAdes4;
        }

        //Gestione per viewAtt
        function setShowPanelAtt1() {
            return vm.showPanelAtt1 = !vm.showPanelAtt1;
        }
        function setShowPanelAtt2() {
            return vm.showPanelAtt2 = !vm.showPanelAtt2;
        }
        function setShowPanelAtt3() {
            return vm.showPanelAtt3 = !vm.showPanelAtt3;
        }

        //Gestione per viewRiep
        function setShowPanelRiep1() {
            return vm.showPanelRiep1 = !vm.showPanelRiep1;
        }


        function getCNDProgetto(cndProgettoUID) {
            return datacontext.cndProgetto_getByUID(cndProgettoUID)
                .then(function (data) {
                    if (data.UID != cndProgettoUID) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    } else { //Codice Progetto corretto
                        vm.cndProgetto = data;
                        //console.info('getCNDProgetto', data);
                        var dt = new Date(vm.cndProgetto.DttmServer);
                        var dtStart = new Date(vm.cndProgetto.DtStart);
                        var dtEnd = new Date(vm.cndProgetto.DtEnd);

                        vm.ore_disp = moment(dtEnd).format('LT');
                        //if (vm.ore_disp == "00:00") vm.ore_disp = "24:00";
                        if (vm.ore_disp == "23:59") vm.ore_disp = "24:00";
                        vm.data_disp = moment(dtEnd).format("DD MMMM YYYY");


                        vm.dtStartClickDay = new Date(vm.cndProgetto.DtStartClickDay);
                        vm.dtEndClickDay = new Date(vm.cndProgetto.DtEndClickDay);

                        vm.isClickDay = vm.cndProgetto.IsClickDay;
                        /*
                        if (dt >= vm.dtStartClickDay && dt <= vm.dtEndClickDay)
                            vm.isClickDay = true;*/

                        vm.endTime = vm.dtStartClickDay;
                        vm.countdown = ((vm.dtStartClickDay - dt) / 1000);

                        //console.info('getCNDProgetto', vm.dtStartClickDay, dt, vm.isClickDay);
                        //console.info('getCNDProgetto', vm.endTime, vm.countdown);

                        if (dt < dtStart) {
                            showAlertDivs('enableBeforeStart');
                        } else if (dt > dtEnd) {
                            showAlertDivs('callExpired');
                        } else {
                            showAlertDivs('');
                        }


                        sectionMenu.setUrlLogoHeader(vm.cndProgetto.LogoHeader);
                        sectionMenu.setLnkPDFBando(vm.cndProgetto.LnkPDFBando);
                        sectionMenu.setLnkPDFManuale(vm.cndProgetto.LnkPDFManuale);
                        sectionMenu.setLnkOfficialSite(vm.cndProgetto.LnkOfficialSite);
                        sectionMenu.setTipoCandidatura(vm.cndProgetto.iTipoCandidatura);
                        sectionMenu.setLabelCF('Codice Fiscale');
                        sectionMenu.setProjectUId(vm.cndProgetto.UID);

                        vm.record.ProgettoId = vm.cndProgetto.Id;
                    }

                },
                    //else
                    function (data) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    }
                );
        }

        $scope.$on('timer-tick', function (event, args) {
            if (args.millis == 0) {
                //console.info('timer-tick', args.millis);
                //vm.isClickDay = true;
            };
        });

        function setCompleted() {
            if (!vm.record.Sent && !vm.record.Completed) {
                bDialog.confirmationDialog('Attenzione', 'Questa operazione comporta la convalida delle informazioni inserite nella "Fase A" e nella "Fase B", pertanto non sar\xE0 possibile apportare modifiche successivamente. Vuoi proseguire?', 'Convalida e procedi').then(
                    function () { //YES
                        vm.record.Completed = true;
                        vm.PdfReady = false;
                        vm.loading = true;
                        return saveOrUpdateAccred().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.Completed = false;
                                return true;
                            }
                            setClassSeqWiz();
                            setStep(2);
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                        setStep(1);
                    }
                );
            }
            else {
                nextStep();
            }
        }

        function setSent() {
            if (!vm.record.Sent) {
                bDialog.confirmationDialog('Attenzione', 'La stampa della "Ricevuta" equivale a dichiarare terminata tutta la procedura telematica; pertanto non sar\xE0 possibile modificare o caricare altri documenti.', 'Procedi').then(
                    function () { //YES
                        vm.record.Sent = true;
                        vm.loading = true;
                        return saveOrUpdateAccred().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.Sent = false;
                                return true;
                            }
                            setClassSeqWiz();
                            printRicevuta();
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
            else {
                printRicevuta();
            }
        }

        function setAttachChecked() {
            if (!vm.record.attachChecked) {
                bDialog.confirmationDialog('Attenzione', 'Si sta proseguendo alla "Fase D", pertanto, non sar\xE0 possibile tornare indietro e/o aggiungere, modificare, eliminare gli allegati caricati a sistema. Procedere? ', 'Procedi').then(
                    function () { //YES
                        vm.record.attachChecked = true;
                        vm.loading = true;
                        return saveOrUpdateAccred().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.attachChecked = false;
                                setStep(2);
                                return false;
                            }
                            setClassSeqWiz();
                            setStep(3);
                            //setView('viewRiep');
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                        setStep(2);
                        return true;
                    }
                );
            }
        }

        function unlockItem() {
            if (vm.record.Completed) {
                var item = vm.record;
                var msg = item.UId;
                bDialog.confirmationDialog('Attenzione', 'Sei sicuro di voler sbloccare l\'ammissione (' + msg + ')', 'OK').then(
                    function () { //YES
                        return datacontext.cndAccreditamento_unlock(item).then(function (data) {
                            if (data != "204") return logError('Errore: operazione non consentita');
                            vm.record.Completed = false;
                            vm.records[vm.index] = vm.record;
                        });
                    },
                    function () { //NO
                        //
                    }
                );
            }
        }

        //***************************
        // Get URL Allegato ACCREDITAMENTO
        /*
        function getPDF_AllA() {
            vm.loading = false;
            return datacontext.cndAccreditamento_findAllA($routeParams.accreditamentoUID, $routeParams.projectUID)
                .then(function (data) {
                    vm.loading = false;
                    if (data && data.url) {
                        return vm.linkPDFAllA = data.url;
                    }
                });
        }

        function getPDF_AllB1() {
            if (vm.record.Adesioni[0] == null || vm.record.Adesioni[0] == '' || vm.record.Adesioni[0] == 0) return;
            vm.loading = false;
            return datacontext.cndDomandaAdesione_findAllB(vm.record.Adesioni[0], $routeParams.projectUID)
                .then(function (data) {
                    vm.loading = false;
                    if (data && data.url) {
                        return vm.linkPDFAllB1 = data.url;
                    }
                });
        }

        function getPDF_AllB2() {
            if (vm.record.Adesioni[1] == null || vm.record.Adesioni[1] == '' || vm.record.Adesioni[1] == 0) {
                return;
            }
            vm.loading = false;
            return datacontext.cndDomandaAdesione_findAllB(vm.record.Adesioni[1], $routeParams.projectUID)
                .then(function (data) {
                    vm.loading = false;
                    if (data && data.url) {
                        return vm.linkPDFAllB2 = data.url;
                    }
                });
        }
        */
        //*******************************
        // Print PDF ACCREDITAMENTOs

        function printAllA() {
            vm.loading = true;
            return datacontext.cndAccreditamento_printAllA($routeParams.projectUID, $routeParams.accreditamentoUID)
                .then(function (data) {
                    vm.loading = false;
                    if (data && data.url) {
                        //recupero allegato appena creato
                        var a = document.createElement("a");
                        a.setAttribute('style', 'display:none');
                        document.body.appendChild(a);

                        a.href = data.url;
                        if ($rootScope.detectIE()) {
                            //window.navigator.msSaveBlob(file, 'AllegatoA_' + $routeParams.accreditamentoUID + '.pdf');
                            //var myWindow = window.open(a.href, 'tab').blur();
                            //myWindow.focus();
                            a.target = 'hiddenIframe';
                        }
                        else
                            a.download = 'AllegatoA_' + $routeParams.accreditamentoUID + '.pdf';
                        a.click();
                        document.body.removeChild(a);

                        return vm.linkPDFAllA = data.url;
                    } else
                        return true;
                });
        }

        function printAllB(item, index) { //ad es. item pu� essere vm.record.Adesioni[0] o vm.record.Adesioni[1] in base al tirocinante
            vm.loading = true;
            var nomeDocumento = "";
            //determino il nome del documento
            switch (parseInt(index)) {
                case 1:
                    nomeDocumento = "AllegatoB_" + vm.tir1_ref;
                    break;
                case 2:
                    nomeDocumento = "AllegatoB_" + vm.tir2_ref;
                    break;
            }

            return datacontext.cndDomandaAdesione_printAllB($routeParams.projectUID, item)
                .then(function (data) {
                    vm.loading = false;
                    if (data && data.url) {

                        //recupero allegato appena creato
                        var a = document.createElement("a");
                        a.setAttribute('style', 'display:none');
                        document.body.appendChild(a);
                        a.href = data.url;
                        if ($rootScope.detectIE()) {
                            //window.navigator.msSaveBlob(file, 'AllegatoB1_' + $routeParams.accreditamentoUID + '.pdf');
                            //var myWindow = window.open(a.href, 'tab').blur();
                            //myWindow.focus();
                            a.target = 'hiddenIframe';
                        }
                        else
                            a.download = nomeDocumento + '.pdf';
                        a.click();
                        document.body.removeChild(a);

                        return vm.linkPDFAllB = data.url;
                    } else
                        return true;
                });
        }

        function printAllC(item, index) { //ad es. item pu� essere vm.record.Adesioni[0] o vm.record.Adesioni[1] in base al tirocinante
            vm.loading = true;
            var nomeDocumento = "";
            //determino il nome del documento
            switch (parseInt(index)) {
                case 1:
                    nomeDocumento = "AllegatoC_" + vm.tir1_ref;
                    break;
                case 2:
                    nomeDocumento = "AllegatoC_" + vm.tir2_ref;
                    break;
            }

            return datacontext.cndDomandaAdesione_printAllC($routeParams.projectUID, item)
                .then(function (data) {
                    vm.loading = false;
                    if (data && data.url) {

                        //recupero allegato appena creato
                        var a = document.createElement("a");
                        a.setAttribute('style', 'display:none');
                        document.body.appendChild(a);
                        a.href = data.url;
                        if ($rootScope.detectIE()) {
                            //window.navigator.msSaveBlob(file, 'AllegatoB1_' + $routeParams.accreditamentoUID + '.pdf');
                            //var myWindow = window.open(a.href, 'tab').blur();
                            //myWindow.focus();
                            a.target = 'hiddenIframe';
                        }
                        else
                            a.download = nomeDocumento + '.pdf';
                        a.click();
                        document.body.removeChild(a);

                        return vm.linkPDFAllC = data.url;
                    } else
                        return true;
                });
        }

        function printRicevuta() {
            if (vm.record.Sent) {
                vm.loading = true;
                return datacontext.cndAccreditamento_printRicevuta($routeParams.projectUID, $routeParams.accreditamentoUID)
                    .then(function (data) {
                        vm.loading = false;
                        if (data && data.url) {
                            //recupero allegato appena creato
                            var a = document.createElement("a");
                            a.setAttribute('style', 'display:none');
                            document.body.appendChild(a);

                            a.href = data.url;
                            if ($rootScope.detectIE()) {
                                //window.navigator.msSaveBlob(file, 'Ricevuta_' + $routeParams.accreditamentoUID + '.pdf');
                                //var myWindow = window.open(a.href, 'tab').blur();
                                //myWindow.focus();
                                a.target = 'hiddenIframe';
                            }
                            else
                                a.download = 'Ricevuta_' + $routeParams.accreditamentoUID + '.pdf';
                            a.click();
                            document.body.removeChild(a);

                            getRecordByUID($routeParams.accreditamentoUID);
                            return vm.linkPDFRicevuta = data.url;
                        } else
                            return true;
                    });
            }
        }

        function setRecord(data) {
            vm.record = data;
            if (vm.record.Deleted || vm.record.Annulled) {
                vm.errorAccess = 'linkError';
                return;
            }
            if (vm.record.Completed)
                return;

            //Abilita questo codice solo per sistemazioni grafiche della comunicazione Link di Accesso
            vm.isVisibleLinkDomanda = true;

            //console.info('setRecord', vm.record);
            //Reset campi Notifiche
            vm.validFieldsCF = true;
            vm.validPIVA = true;
            vm.validCF = true;
            //vm.existsL_CF = false;
            //vm.existsPIVA = false;            
            //vm.existsCF = false;


            //Converto ogni object Date in una data
            //Object.getOwnPropertyNames(vm.record).forEach(function (prop) {
            //    if (typeof (vm.record[prop]) === 'string' && (vm.record[prop]).indexOf("T00:00:00") > -1) vm.record[prop] = new Date(vm.record[prop]);
            //});

            if (vm.record.L_DtNasc != null) vm.record.L_DtNasc = new Date(vm.record.L_DtNasc);
            if (vm.record.DDG_Dt != null) vm.record.DDG_Dt = new Date(vm.record.DDG_Dt);
            if (vm.record.All_Data != null) vm.record.All_Data = new Date(vm.record.All_Data);
            if (vm.record.Decreto_Data != null) vm.record.Decreto_Data = new Date(vm.record.Decreto_Data);
            if (vm.record.DtConvalida != null) vm.record.DtConvalida = new Date(vm.record.DtConvalida);

            if (vm.record.Email != null) vm.confirm.Email = vm.record.Email;
            if (vm.record.PEC != null) vm.confirm.PEC = vm.record.PEC;
            if (vm.record.Dich_PEC != null) vm.confirm.Dich_PEC = vm.record.Dich_PEC;
            if (vm.record.L_Email != null) vm.confirm.L_Email = vm.record.L_Email;

            if (vm.adesione.ResPaeseId == 0) { vm.tir_maxLenResCAP = 5; }
            else { vm.tir_maxLenResCAP = 15; }

            //Azzera liste
            vm.list.attach = [];
            vm.list.b_attach = false;
            //vm.existsL_CF = false;
            //vm.existsCF = false;
            //vm.existsPIVA = false;
            //vm.existsIPA = false;

            //Aggiorno campi
            getComuni(vm.record.ProvinciaId);
            getComuniNasc(vm.record.L_ProvNascId);
            getComuni_Res(vm.record.L_ResProvinciaId);
            getComuni_Dom(vm.record.L_DomProvinciaId);
            getComuni_SedeOp(vm.record.SedeOp_ProvinciaId);
            getComuni_SedeTir(vm.adesione.Trc_SedeProvinciaId);
            getAteco(vm.record.TAtecoId);

            vm.myPristine = true;
            vm.changeForm = false;
        }

        //$(document).on("contextmenu", "#confirm1", function (e) {
        //    logError('Attenzione: la funzionalit\xE0 \xE8 disabilitata. ');
        //    return false;
        //});

        //$(document).on("contextmenu", "#confirm2", function (e) {
        //    logError('Attenzione: la funzionalit\xE0 \xE8 disabilitata. ');
        //    return false;
        //});

        //function getConfirmEMAIL(value1, value2) {
        //    if (value1 == '' || value1 == null) return;

        //    if (value1.toLowerCase() != value2.toLowerCase())
        //        return false;
        //    else
        //        return true;
        //}

        /*
		function getRecord(id, index) {
            if (vm.province.length == 0) getProvince();
            if (vm.cmblist.res_province.length == 0) getProvince_Res();

			return datacontext.cndAccreditamento_get(id).then(function (data) {
                vm.index = index;
                setRecord(data); //vm.record = data;

				setView('detail');
			});
        }
        */

        function showAlertDivs(errorAccess) {
            var msg = '';

            vm.errorAccess = errorAccess;

            if (errorAccess == 'linkError') {
                msg = 'Attenzione! Il link utilizzato e\' errato.';
            }

            if (msg != '') return logError(msg);

            return false;
        }

        function getRecordByUID(uid) {
            return datacontext.cndAccreditamento_getByUID(uid, $routeParams.projectUID).then(function (data) {
                if (data == null || $.isNumeric(data) || data.Id == 0) {
                    showAlertDivs('linkError');
                    return false;
                }

                vm.myPristine = false;
                //Parametro di appoggio per send_Email
                vm.record.ProgettoUId = $routeParams.projectUID;
                //Riduco il pannello con le modalit� di utilizzo dello strumento
                vm.showInfoMsg = false;
                //Riduco i pannelli dei dati dopo averli convalidati
                /*
                vm.showPanelAccred1 = false;
                vm.showPanelAccred2 = false;
                vm.showPanelAccred3 = false;                    
                vm.showPanelAccred4 = false;
                */

                setRecord(data); //vm.record = data;
                setStepDefault();

                //vm.list.cndAccreditamentiSedi = [];
                //getAllCNDAccreditamentiSedi(vm.record.ProgettoId, vm.record.Id);

                /*
                var AdesioneId = 0;
                if (vm.record.Adesioni.length > 0) AdesioneId = vm.record.Adesioni[0];
                getAdesione(AdesioneId);
                return setStep(1);
                */

                //setView('viewAccred');
            });
        }



        function resetAdesioneForm() {
            vm.adesione = {};
            vm.adesione.Id = 0;
            vm.adesione.ProgettoUId = $routeParams.projectUID;
            vm.adesione.AccreditamentoId = vm.record.Id;
            vm.adesione.ProgettoId = vm.record.ProgettoId;
            vm.adesione.iFinestra = vm.record.iFinestra;

            vm.adesione.NascPaeseId = 0;
            vm.adesione.ResPaeseId = 0;
            vm.adesione.CittadinanzaId = 0;
            vm.adesione.DomPaeseId = 0;
            vm.adesione.bDomUgualeRes = false;


            vm.confirm.TirEmail = '';
            vm.confirm.TirPEC = '';
            vm.nrMesiTrc = 0;

            vm.cmblist.tir_res_comuni = [];
            vm.cmblist.tir_dom_comuni = [];
            vm.cmblist.tir_nasc_comuni = [];
            vm.cmblist.tir_sede_comuni = [];
            vm.cmblist.trcObbl_comuni = [];
            /*
            vm.adesione.NascProvinciaId = 0;
            vm.adesione.NascComuneId = 0;
            vm.adesione.ResProvinciaId = 0;
            vm.adesione.ResComuneId = 0;
            vm.adesione.DomProvinciaId = 0;
            vm.adesione.DomComuneId = 0;
            vm.adesione.TrcObbl_ProvinciaId = 0;
            vm.adesione.TrcObbl_ComuneId = 0;
            vm.adesione.TrcObbl_Comune = '';
            */
        }

        function getAdesione(id) {
            if (id == 0) {
                resetAdesioneForm();
            } else {
                return datacontext.cndDomandaAdesione_get(id).then(function (data) {
                    setAdesione(data);
                    //setAdesione(data);  

                    vm.myPristine = false;
                    //console.info('getAdesione', vm.myPristine);

                    if (vm.adesione.Id > 0) {
                        //Riduco i pannelli dei dati dopo averli salvati
                        /*
                        vm.showPanelAdes1 = false;
                        vm.showPanelAdes2 = false;
                        vm.showPanelAdes3 = false;
                        vm.showPanelAdes4 = false;
                        */

                    }
                });
            }
        }

        function setAdesione(data) {
            vm.adesione = data;

            if (vm.adesione.Completed)
                return;
            //Reset campi Notifiche
            //vm.existsCF = false;
            vm.validFieldsCFTir = true;

            //Converto ogni object Date in una data
            //Object.getOwnPropertyNames(vm.adesione).forEach(function (prop) {
            //    if (typeof (vm.adesione[prop]) === 'string' && (vm.adesione[prop]).indexOf("T00:00:00") > -1) vm.adesione[prop] = new Date(vm.adesione[prop]);
            //});

            if (vm.adesione.DtProt != null) vm.adesione.DtProt = new Date(vm.adesione.DtProt);
            if (vm.adesione.NascData != null) vm.adesione.NascData = new Date(vm.adesione.NascData);
            if (vm.adesione.Trc_DtStartPrev != null) vm.adesione.Trc_DtStartPrev = new Date(vm.adesione.Trc_DtStartPrev);
            if (vm.adesione.Trc_DtEndPrev != null) vm.adesione.Trc_DtEndPrev = new Date(vm.adesione.Trc_DtEndPrev);
            if (vm.adesione.TrcObbl_DtIscrizione != null) vm.adesione.TrcObbl_DtIscrizione = new Date(vm.adesione.TrcObbl_DtIscrizione);
            if (vm.adesione.All_Data != null) vm.adesione.All_Data = new Date(vm.adesione.All_Data);
            if (vm.adesione.DtConvalida != null) vm.adesione.DtConvalida = new Date(vm.adesione.DtConvalida);

            if (vm.adesione != null && vm.adesione.Email != null) vm.confirm.TirEmail = vm.adesione.Email;
            if (vm.adesione != null && vm.adesione.PEC != null) vm.confirm.TirPEC = vm.adesione.PEC;


            //Aggiorno campi
            getComuni_TrcObbl(vm.adesione.TrcObbl_ProvinciaId);
            getComuni_ResTir(vm.adesione.ResProvinciaId);
            getComuni_DomTir(vm.adesione.DomProvinciaId);
            getComuni_NascTir(vm.adesione.NascProvinciaId);
            getComuni_SedeTir(vm.adesione.Trc_SedeProvinciaId);

            vm.myPristine = true;
            vm.changeForm = false;
        }


        function saveOrUpdateAccred() {
            unResetAccred(vm.record);
            var msgExistAccr = 'Attenzione: tentativo di duplicazione. ';
            if (vm.record.IsAzienda)
                msgExistAccr = msgExistAccr + 'La "Partita IVA" dell\'azienda \xE8 gi\xE0 presente a sistema. ';
            else
                msgExistAccr = msgExistAccr + 'Il "Codice Fiscale" del libero professionista \xE8 gi\xE0 presente a sistema. ';
            if (typeof (vm.record.Id) == 'undefined' || vm.record.Id == null || vm.record.Id == 0) {
                bDialog.confirmationDialog('Attenzione', 'Si sta effettuando il primo salvataggio; la pratica sar\xE0 acquisita nel sistema informativo. Procedere?', 'OK').then(
                    function () { //YES
                        //Parametro di appoggio per send_Email
                        vm.record.ProgettoUId = $routeParams.projectUID;
                        vm.record.iFinestra = vm.iFinestra;
                        vm.loading = true;
                        return datacontext.cndAccreditamento_add(vm.record).then(function (data) {
                            vm.loading = false;
                            if (data == "400") {
                                logError('Errore campi non validi. ');
                                return data;
                            }
                            if (data == "304") {
                                logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                                return data;
                            }
                            if (data == "409") {
                                logError(msgExistAccr); //Domanda esistente
                                return data;
                            }
                            if (data == "300") {
                                logError('Errore: partita IVA non valida. ');
                                return data;
                            }
                            if (data == "501") {
                                logError('Errore: codice fiscale del "Rappresentante Legale" non valido. Si verifichino i campi corrispondenti ');
                                return data;
                            }
                            if (data == "203") {
                                logError('Errore: codice fiscale del "Tutor Professionale" non valido. Si verifichino i campi corrispondenti ');
                                return data;
                            }
                            if ($.isNumeric(data)) {
                                logError('Errore non specificato. Impossibile registrare i dati inseriti.');
                                return data;
                            }

                            if (data) {
                                setRecord(data); //vm.record = data;
                                vm.myPristine = true;
                                vm.changeForm = false;
                                //console.info('saveOrUpdateAccred', vm.myPristine);

                                $routeParams.accreditamentoUID = vm.record.UID;

                                if (vm.record.Id > 0) {
                                    //Riduco il pannello con le modalit� di utilizzo dello strumento
                                    vm.showInfoMsg = false;

                                    //Riduco i pannelli dei dati dopo averli convalidati
                                    /*
                                    vm.showPanelAccred1 = false;
                                    vm.showPanelAccred2 = false;
                                    vm.showPanelAccred3 = false;
                                    vm.showPanelAccred4 = false;
                                    */
                                }
                                return logSuccess('E\' stata inviata una email all\'indirizzo ' + vm.record.L_Email + ' con il link ai dati inseriti. ');
                            }
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            } else {
                vm.loading = true;
                return datacontext.cndAccreditamento_update(vm.record).then(function (data) {
                    vm.loading = false;
                    if (data == "304") {
                        logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                        return data;
                    }
                    if (data == "300") {
                        logError('Errore: partita IVA non valida. ');
                        return data;
                    }
                    if (data == "406") {
                        vm.record.attachChecked = false;
                        logError("Attenzione mancano alcuni allegati necessari, inserirli prima di passare alla Fase successiva. ");
                        return data;
                    }
                    if (data == "409") {
                        logError(msgExistAccr); //Domanda esistente
                        return data;
                    }
                    if (data == "501") {
                        logError('Errore: codice fiscale del "Rappresentante Legale" non valido. Si verifichino i campi corrispondenti ');
                        return data;
                    }
                    if (data == "203") {
                        vm.saving = false;
                        logError('Errore: codice fiscale del "Tutor Professionale" non valido. Si verifichino i campi corrispondenti ');
                        return data;
                    }
                    if (data == "406") {
                        logError('Errore: allegato non disponibile ');
                        return data;
                    }
                    if (data == "502") {
                        logError('Funzionalit\xE0 non ancora disponibile, vedi Linee Guida Avviso');
                        return data;
                    }
                    if ($.isNumeric(data)) {
                        logError('Errore generico. Impossibile proseguire.');
                        return data;
                    }

                    if (data) {
                        setRecord(data); //vm.record = data;
                        vm.myPristine = true;
                        vm.changeForm = false;
                        $routeParams.accreditamentoUID = vm.record.UID;
                        logSuccess('Dati salvati');
                        return true;
                    }
                });
            }
        }

        function saveOrUpdateAdes() {
            if (vm.adesione.Voto > vm.adesione.VotoMax)
                return logError('Attenzione: il "Voto" \xE8 maggiore del "Voto Massimo". ');
            //console.info('vm.adesione', vm.adesione);
            //console.info('saveOrUpdateAdes 0', vm.myPristine);
            unResetTirItem(vm.adesione);
            //console.info('saveOrUpdateAdes 1a', vm.myPristine);
            if (typeof (vm.adesione.Id) == 'undefined' || vm.adesione.Id == null || vm.adesione.Id == 0) {
                //Parametro di appoggio per send_Email
                vm.adesione.ProgettoUId = $routeParams.projectUID;
                vm.adesione.AccreditamentoId = vm.record.Id;
                vm.adesione.ProgettoId = vm.record.ProgettoId;
                vm.adesione.iFinestra = vm.record.iFinestra;
                vm.loading = true;
                //console.info('saveOrUpdateAdes 1', vm.myPristine);
                return datacontext.cndDomandaAdesione_add(vm.adesione).then(function (data) {
                    vm.loading = false;
                    //console.info('saveOrUpdateAdes 2', vm.myPristine);
                    if (data == "406") {
                        logError('Errore: superato il numero massimo di tirocinanti permessi. ');
                        return data;
                    }
                    if (data == "409") {
                        logError('Errore: codice fiscale esistente per la domanda di partecipazione. ');
                        return data;
                    }
                    if (data == "304") {
                        logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                        return data;
                    }
                    if (data == "417") {
                        logError('Errore: importo ISEE oltre il valore consentito ');
                        return data;
                    }
                    if (data == "501") {
                        logError('Errore: codice fiscale non valido. Si verifichino i campi corrispondenti ');
                        return data;
                    }
                    if ($.isNumeric(data)) {
                        logError('Errore non specificato. Impossibile registrare i dati inseriti.');
                        return data;
                    }

                    if (data) {
                        vm.myPristine = true;
                        vm.changeForm = false;
                        //console.info('saveOrUpdateAdes 3', vm.myPristine);
                        setAdesione(data);
                        if (vm.record.Adesioni == undefined)
                            vm.record.Adesioni = [];
                        return getAdesMiniDto(data.Id).then(function (data2) {
                            vm.record.Adesioni[vm.actualAdesione] = data2;
                            /*
                            vm.record.Adesioni[vm.actualAdesione].Id = data.Id;
                            vm.record.Adesioni[vm.actualAdesione].Tirocinante = data.Cognome + ' ' + data.Nome + ' (' + data.CodiceFiscale + ')';
                            vm.record.Adesioni[vm.actualAdesione].UID = data.UID;
                            vm.record.Adesioni[vm.actualAdesione].AllC_HasAlready = data.AllC_HasAlready;
                            */

                            //$routeParams.domandaAdesioneUID = vm.adesione.UID;

                            if (vm.adesione.Id > 0) {
                                //Riduco i pannelli dei dati dopo averli convalidati
                                /*
                                vm.showPanelAdes1 = false;
                                vm.showPanelAdes2 = false;
                                vm.showPanelAdes3 = false;
                                vm.showPanelAdes4 = false;
                                */
                            }
                            logSuccess('Dati inseriti con Successo. ');
                            return true;
                        });
                    }
                });
            }
            else {
                vm.loading = true;
                return datacontext.cndDomandaAdesione_update(vm.adesione).then(function (data) {
                    vm.loading = false;
                    if (data == "409") {
                        logError('Errore: codice fiscale esistente per la domanda di partecipazione. ');
                        return data;
                    }
                    if (data == "304") {
                        logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                        return data;
                    }
                    if (data == "406") {
                        vm.adesione.Sent = false;
                        logError("Attenzione mancano alcuni allegati necessari, inserirli prima di effettuare la trasmissione. ");
                        return data;
                    }
                    if (data == "417") {
                        logError('Errore: importo ISEE oltre il valore consentito ');
                        return data;
                    }
                    if ($.isNumeric(data)) {
                        logError('Errore non specificato. Impossibile registrare i dati inseriti.');
                        return data;
                    }

                    if (data) {
                        vm.myPristine = true;
                        vm.changeForm = false;
                        //console.info('saveOrUpdateAdes 3', vm.myPristine);
                        setAdesione(data);
                        logSuccess('Dati salvati');
                        return true;
                    }
                });
            }
        }

        function deleteAdes() {
            var msg = 'Eliminando il modello di dichiarazione del tirocinante : ' + vm.adesione.Cognome + ' ' + vm.adesione.Nome + ' ' + vm.adesione.CodiceFiscale;
            bDialog.confirmationDialog('Attenzione', msg + '; saranno cancellati tutti gli eventuali allegati dello stesso.', 'Conferma')
                .then(function () {
                    vm.loading = true;
                    return datacontext.cndDomandaAdesione_delete(vm.adesione.Id).then(function (data) {
                        vm.loading = false;
                        if (data != "204") return logError('Errore cancellazione dati');

                        //console.info('deleteAdes', vm.record.Adesioni, vm.record.Adesioni.length, vm.actualAdesione);
                        vm.record.Adesioni.splice(vm.actualAdesione, 1);
                        //console.info('deleteAdes', vm.record.Adesioni, vm.record.Adesioni.length, vm.actualAdesione);
                        var actualMaxAdesioni = vm.record.Adesioni.length;

                        if (vm.actualAdesione == actualMaxAdesioni) {
                            vm.actualAdesione = vm.actualAdesione - 1;
                        }
                        if (vm.actualAdesione >= 0) {
                            getAdesione(vm.record.Adesioni[vm.actualAdesione].Id);
                        } else {
                            getAdesione(0);
                        }

                        setStep(vm.actualStep);

                        return logSuccess('Tirocinio eliminato');
                    });
                });
        }

        //AdesMiniDto
        function getAdesMiniDto(id) {
            if (!id) return;
            return datacontext.cndDomandaAdesione_getMiniDto(id).then(function (data) {
                return data;
            });
        }

        function unResetAccred(item) {
            if (item.bDomUgualeRes) {
                item.L_DomPaeseId = 0;
                item.L_DomProvinciaId = 0;
                item.L_DomComuneId = 0;
                item.L_DomIndirizzo = '';
                item.L_DomCAP = '';
            }

            if (item.bSedeOperativa) {
                item.SedeOp_ProvinciaId = 0;
                item.SedeOp_ComuneId = 0;
                item.SedeOp_Indirizzo = '';
                item.SedeOp_CAP = '';
            }

            if (item.L_PaeseNascId > 0) {
                item.L_ProvNascId = 0;
                item.L_ComuneNascId = 0;
            }

            if (item.L_ResPaeseId > 0) {
                item.L_ResProvinciaId = 0;
                item.L_ResComuneId = 0;
            }

            if (item.L_DomPaeseId > 0) {
                item.L_DomProvinciaId = 0;
                item.L_DomComuneId = 0;
            }

            if (!item.L_CittadinanzaId) {
                item.L_CittadinanzaId = 0;
            }
        }

        function unResetTirItem(item) {
            if (item.bDomUgualeRes) {
                item.DomPaeseId = 0;
                item.DomProvinciaId = 0;
                item.DomComuneId = 0;
                item.DomIndirizzo = '';
                item.DomCap = '';
            }

            if (item.NascPaeseId > 0) {
                item.NascProvinciaId = 0;
                item.NascComuneId = 0;
            }

            if (item.ResPaeseId > 0) {
                item.ResProvinciaId = 0;
                item.ResComuneId = 0;
            }

            if (item.DomPaeseId > 0) {
                item.DomProvinciaId = 0;
                item.DomComuneId = 0;
            }

            if (!item.CittadinanzaId) {
                item.CittadinanzaId = 0;
            }

            if (!item.IsTrcObbl) {
                item.TrcObbl_ProvinciaId = 0;
                item.TrcObbl_ComuneId = 0;
            }

            if (item.AllC_HasAlready) {
                item.Trc_SedeProvinciaId = 0;
                item.Trc_SedeComuneId = 0;
                item.Trc_SedeIndirizzo = '';
                item.Trc_SedeCAP = '';
                item.Trc_OreWeek = 0;
            }
        }

        function addTir() {
            if (vm.record.Adesioni.length < vm.maxAdesioni) {

                //Esapndo i pannelli dei dati
                vm.showPanelAdes1 = true;
                vm.showPanelAdes2 = true;
                vm.showPanelAdes3 = true;
                vm.showPanelAdes4 = true;

                getAdesione(0);
            }
            else {
                return log('Massimo numero di tirocini raggiunto');
            }
        }

        function deleteItem(item) {
            var msg = ' la azienda : ' + item.RagioneSociale;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.cndAccreditamento_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore cancellazione dati [' + data + ']');

                    var index = vm.records.indexOf(item)
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }


        function pubblico_click() {
            if (!vm.record.Pubblico)
                vm.record.IPA = '';
        }

        function bSuspended_click() {
            if (!vm.record.bSuspended)
                vm.record.DtSuspended = '';
        }


        function reset_PaeseNasc() {
            if (vm.record.L_PaeseNascId != 0) {
                vm.record.L_ProvNascId = 0;
                resetComuniNasc(0);
            }
        }

        //******************************
        // Birth - Adesione
        function getPaesi_NascTir() {
            if (vm.cmblist.tir_nasc_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.tir_nasc_paesi = data;
            });
        }

        function getProvince_NascTir() {
            if (vm.cmblist.tir_nasc_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.tir_nasc_province = data;
            });
        }

        function resetComuni_NascTir(idprov) {
            vm.adesione.NascComuneId = 0;
            getComuni_NascTir(idprov);
        }

        function getComuni_NascTir(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.tir_nasc_comuni = [];
            }

            if (vm.adesione.NascProvinciaId != idprov)
                vm.cmblist.tir_nasc_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.tir_nasc_comuni = data;
            });
        }

        function reset_PaeseNascTir() {
            if (vm.adesione.NascPaeseId != 0) {
                vm.adesione.NascProvinciaId = 0;
                resetComuni_NascTir(0);
            }
        }
        /**************************************/

        //******************************
        // Residenza - Adesioni
        function getPaesi_ResTir() {
            if (vm.cmblist.tir_res_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.tir_res_paesi = data;
            });
        }

        function getProvince_ResTir() {
            if (vm.cmblist.tir_res_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.tir_res_province = data;
            });
        }

        function resetComuni_ResTir(idprov) {
            vm.adesione.ResComuneId = 0;
            getComuni_ResTir(idprov);
        }

        function getComuni_ResTir(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.tir_res_comuni = [];
            }

            if (vm.adesione.ResProvinciaId != idprov)
                vm.cmblist.tir_res_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.tir_res_comuni = data;
            });
        }


        function reset_PaeseResTir() {
            if (vm.adesione.ResPaeseId != 0) {
                vm.adesione.ResProvinciaId = 0;
                resetComuni_ResTir(0);
            }
        }


        //******************************
        // Residenza
        function getPaesi_Res() {
            if (vm.cmblist.res_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.res_paesi = data;
            });
        }

        function getProvince_Res() {
            if (vm.cmblist.res_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.res_province = data;
            });
        }

        function resetComuni_Res(idprov) {
            vm.record.L_ResComuneId = 0;
            getComuni_Res(idprov);
        }
        function getComuni_Res(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.res_comuni = [];
            }

            if (vm.record.ResProvinciaId != idprov)
                vm.cmblist.res_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.res_comuni = data;
            });
        }


        function reset_PaeseRes() {
            if (vm.record.L_ResPaeseId != 0) {
                vm.record.L_ResProvinciaId = 0;
                resetComuni_Res(0);
            }
        }

        //******************************
        // Cittadinanze
        function getCittadinanze() {
            if (vm.cmblist.cittadinanze.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.cittadinanze = data;
            });
        }

        //******************************
        // Domicilio
        function getPaesi_Dom() {
            if (vm.cmblist.dom_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.dom_paesi = data;
            });
        }

        function getProvince_Dom() {
            if (vm.cmblist.dom_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.dom_province = data;
            });
        }

        function resetComuni_Dom(idprov) {
            vm.record.L_DomComuneId = 0;
            getComuni_Dom(idprov);
        }
        function getComuni_Dom(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.dom_comuni = [];
            }

            if (vm.record.DomProvinciaId != idprov)
                vm.cmblist.dom_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.dom_comuni = data;
            });
        }


        function reset_PaeseDom() {
            if (vm.record.L_DomPaeseId != 0) {
                vm.record.L_DomProvinciaId = 0;
                resetComuni_Dom(0);
            }
        }

        //******************************
        // Domicilio
        function getPaesi_DomTir() {
            if (vm.cmblist.tir_dom_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.tir_dom_paesi = data;
            });
        }

        function getProvince_DomTir() {
            if (vm.cmblist.tir_dom_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.tir_dom_province = data;
            });
        }

        function resetComuni_DomTir(idprov) {
            vm.adesione.DomComuneId = 0;
            getComuni_DomTir(idprov);
        }
        function getComuni_DomTir(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.tir_dom_comuni = [];
            }

            if (vm.adesione.DomProvinciaId != idprov)
                vm.cmblist.tir_dom_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.tir_dom_comuni = data;
            });
        }

        function getProvince_SedeTir() {
            if (vm.cmblist.tir_sede_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.tir_sede_province = data;
            });
        }

        function resetComuni_SedeTir(idprov) {
            vm.adesione.Trc_SedeComuneId = 0;
            getComuni_SedeTir(idprov);
        }
        function getComuni_SedeTir(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.tir_sede_comuni = [];
            }

            if (vm.adesione.Trc_SedeProvinciaId != idprov)
                vm.cmblist.tir_sede_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.tir_sede_comuni = data;
            });
        }


        function reset_PaeseDomTir() {
            if (vm.adesione.DomPaeseId != 0) {
                vm.adesione.DomProvinciaId = 0;
                resetComuni_DomTir(0);
            }
        }

        //Sede Operativa
        function getProvince_SedeOp() {
            if (vm.cmblist.sedeOp_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.sedeOp_province = data;
            });
        }

        function resetComuni_SedeOp(idprov) {
            vm.record.SedeOp_ComuneId = 0;
            getComuni_SedeOp(idprov);
        }
        function getComuni_SedeOp(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.sedeOp_comuni = [];
            }

            if (vm.record.SedeOp_ProvinciaId != idprov)
                vm.cmblist.sedeOp_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.sedeOp_comuni = data;
            });
        }

        //TrcObbl - Comune
        function getProvince_TrcObbl() {
            if (vm.cmblist.trcObbl_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.trcObbl_province = data;
            });
        }

        function resetComuni_TrcObbl(idprov) {
            vm.adesione.TrcObbl_ComuneId = 0;
            getComuni_TrcObbl(idprov);
        }
        function getComuni_TrcObbl(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.trcObbl_comuni = [];
            }

            if (vm.adesione.TrcObbl_ProvinciaId != idprov)
                vm.cmblist.trcObbl_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.trcObbl_comuni = data;
            });
        }

        //Titoli studio
        function getTitoliStudio() {
            if (vm.cmblist.titoliStudio.length > 0) return;

            return datacontext.arrTitoliStudio().then(function (data) {

                data = _.filter(data, function (o) { return o.Codice == 40 || (o.Codice >= 70 && o.Codice < 80); });

                return vm.cmblist.titoliStudio = data;
            });
        }

        //Reset Field of Tirocinio Obbligatorio
        function reset_TrcObbl() {
            if (vm.adesione.IsTrcObbl == undefined || vm.adesione.IsTrcObbl == false) {
                vm.adesione.TrcObbl_Ordine = '';
                vm.adesione.TrcObbl_numRegistro = '';
                vm.adesione.TrcObbl_DtIscrizione = '';
                vm.adesione.TrcObbl_ProvinciaId = '';
                vm.adesione.TrcObbl_ComuneId = '';
            }
        }

        function reset_TrcAvviato() {
            if (vm.adesione.TrcAvviato == undefined || vm.adesione.TrcAvviato == false) {
                vm.adesione.Trc_DtStartPrev = '';
                vm.adesione.Trc_DtEndPrev = '';
            }
        }


        /***************************************** */
        function setFieldsResTir() {
            if (vm.adesione.ResPaeseId == 0) { vm.tir_maxLenResCAP = 5; }
            else { vm.tir_maxLenResCAP = 15; }
        }


        function getAteco(id) {
            return datacontext.tAteco_get(id).then(function (data) {
                console.info('getAteco', data);
                if (data != null)
                    vm.record.searchTextAteco = data.Title;
            });
        }
        function getTAteco() {
            if (vm.cmblist.ateco.lenght > 0) return;

            datacontext.arrTipoAteco().then(function (data) {
                vm.cmblist.ateco = data;
            });
        }


        /*
        function getVotoLode() {
            if (vm.adesione.Voto != undefined && vm.adesione.VotoMax != undefined) {
                if (vm.adesione.VotoLode == true && parseInt(vm.adesione.Voto) != parseInt(vm.adesione.VotoMax)) {
                    return logError('Attenzione: il voto \xE8 diverso dal voto massimo');
                }                    
            }
            return;
        }
        */

        //Reset Field of Azienda
        function reset_Azienda() {
            if (vm.record.IsAzienda == undefined || vm.record.IsAzienda == false) {
                vm.record.RagioneSociale = '';
                vm.record.CodiceFiscale = '';
                vm.record.PIVA = '';
                vm.record.Indirizzo = '';
                vm.record.Cap = '';
                vm.record.ProvinciaId = 0;
                vm.record.ComuneId = 0;
                vm.record.Telefono = '';
                vm.record.Cellulare = '';
                vm.record.Email = '';
                vm.confirm.Email = '';
                vm.record.PEC = '';
                vm.confirm.PEC = '';
                vm.record.SedeOp_Indirizzo = '';
                vm.record.SedeOp_CAP = '';
                vm.record.SedeOp_ProvinciaId = 0;
                vm.record.SedeOp_ComuneId = 0;
            }
            else {
                vm.record.L_PIVA = '';
            }
        }

        function reset_SedeOperativa() {
            if (vm.record.bSedeOperativa == undefined || vm.record.bSedeOperativa == false) {
                vm.record.SedeOp_Indirizzo = '';
                vm.record.SedeOp_CAP = '';
                vm.record.SedeOp_ProvinciaId = 0;
                vm.record.SedeOp_ComuneId = 0;
            }
        }

        //Reset Fiel Domicilio
        function reset_DomUgualeRes() {
            if (vm.record.bDomUgualeRes) {
                vm.record.L_DomPaeseId = '';
                vm.record.L_DomProvinciaId = '';
                vm.record.L_DomComuneId = '';
                vm.record.L_DomIndirizzo = '';
                vm.record.L_DomCAP = '';
                vm.record.L_DomTel = '';
            }
        }

        //Reset Fiel Domicilio - Adesione
        function reset_DomUgualeResTir() {
            if (vm.adesione.bDomUgualeRes) {
                vm.adesione.DomPaeseId = '';
                vm.adesione.DomProvinciaId = '';
                vm.adesione.DomComuneId = '';
                vm.adesione.DomIndirizzo = '';
                vm.adesione.DomCap = '';
            }
        }

        function reset_AllC() {
            if (vm.adesione.AllC_HasAlready) {
                vm.adesione.AllC_SettProfessionale = '';
                vm.adesione.AllC_ObFormativi = '';
                vm.adesione.AllC_AttPreviste = '';
                vm.adesione.AllC_CompAcquisire = '';
                vm.adesione.AllC_Contesto = '';
                vm.adesione.AllC_ModSvolgimento = '';
                vm.adesione.AllC_CompetenzeTutor = '';
                vm.adesione.AllC_AttivitaTutor = '';
                vm.adesione.Trc_SedeProvinciaId = '';
                vm.adesione.Trc_SedeComuneId = '';
                vm.adesione.Trc_SedeIndirizzo = '';
                vm.adesione.Trc_SedeCAP = '';
                vm.adesione.Trc_OreWeek = '';
            }
        }

        function getNrMesiTrc() {
            vm.nrMesiTrc = 0;
            if (vm.adesione.Trc_DtStartPrev != null && vm.adesione.Trc_DtEndPrev != null) {
                var dtStart = moment(vm.adesione.Trc_DtStartPrev);
                var dtEnd = moment(vm.adesione.Trc_DtEndPrev);

                //Differenza in mesi
                var diffValue = dtEnd.diff(dtStart, 'months', true);
                if (isNaN(diffValue))
                    diffValue = 0;

                if (diffValue < 0 || diffValue > 23) {
                    //Arrotondo per eccesso in ogni caso
                    vm.nrMesiTrc = (diffValue % 1) == 0 ? parseFloat(diffValue.toFixed()) : parseInt(diffValue) + 1;
                }
            }
            else
                vm.nrMesiTrc = 0;

            //console.info('getNrMesiTrc', diffValue, vm.nrMesiTrc);
            return vm.nrMesiTrc;
        }

        function getValidDate() {
            vm.validDate = true;
            if (vm.adesione.Trc_DtStartPrev != null && vm.adesione.Trc_DtEndPrev != null) {
                if (vm.adesione.Trc_DtStartPrev > vm.adesione.Trc_DtEndPrev)
                    vm.validDate = false;
            }

            return vm.validDate;
        }

        function setComuneTrcObbl(_id) {
            if (_id == undefined || _id == 0) return;

            var comune = '';
            vm.cmblist.trcObbl_comuni.forEach(function (c) {
                if (c.Id == _id)
                    comune = c.Nome;
            });

            if (comune != null && comune != undefined && comune != '')
                vm.adesione.TrcObbl_Comune = comune;

            return vm.adesione.TrcObbl_Comune;
        }




        //**********************************************************************
        //GESTIONE ATTACH 2

        function getAdesioneById(id) {
            if (!id) return;
            return datacontext.cndDomandaAdesione_get(id).then(function (data) {
                if (!data) return;
                return data;
            });
        }

        function resetListAttach() {
            vm.accr_ref = '';
            vm.tir1_ref = '';
            vm.tir2_ref = '';

            vm.list.attach_accr = [];
            vm.list.attach_tir1 = [];
            vm.list.attach_tir2 = [];
        }

        function populateAttach() {
            resetListAttach();

            if (vm.record != undefined && vm.record.Id != 0 && vm.record.Id != undefined) {
                vm.accr_ref = vm.record.L_Cognome + ' ' + vm.record.L_Nome + ' (' + vm.record.L_CodiceFiscale + ')';
                return getListAttach($routeParams.accreditamentoUID, vm.record.Id, vm.tSourceCode_ACCR).then(function (accr) {
                    vm.list.attach_accr = vm.list_ATT.slice();

                    if (vm.record != undefined && vm.record.Adesioni != undefined && vm.record.Adesioni.length > 0) {
                        vm.tir1_ref = vm.record.Adesioni[0].Tirocinante;
                        return getListAttach(vm.record.Adesioni[0].UID, vm.record.Adesioni[0].Id, vm.tSourceCode_ADES).then(function (tir1) {
                            vm.list.attach_tir1 = vm.list_ATT.slice();

                            if (vm.record.Adesioni.length > 1) {
                                vm.tir2_ref = vm.record.Adesioni[1].Tirocinante;

                                return getListAttach(vm.record.Adesioni[1].UID, vm.record.Adesioni[1].Id, vm.tSourceCode_ADES).then(function (tir2) {
                                    vm.list.attach_tir2 = vm.list_ATT.slice();
                                    return true;
                                });
                            }

                            return true;
                        });
                        /*
                        return getAdesioneById(vm.record.Adesioni[0].Id).then(function (ades_1) {
                            vm.tir1_ref = ades_1.Cognome + ' ' + ades_1.Nome + ' (' + ades_1.CodiceFiscale + ')';

                            return getListAttach(ades_1.UID, ades_1.Id, vm.tSourceCode_ADES).then(function (tir1) {
                                vm.list.attach_tir1 = vm.list_ATT.slice();

                                if (vm.record.Adesioni.length > 1) {
                                    return getAdesioneById(vm.record.Adesioni[1].Id).then(function (ades_2) {
                                        vm.tir2_ref = ades_2.Cognome + ' ' + ades_2.Nome + ' (' + ades_2.CodiceFiscale + ')';

                                        return getListAttach(ades_2.UID, ades_2.Id, vm.tSourceCode_ADES).then(function (tir2) {
                                            vm.list.attach_tir2 = vm.list_ATT.slice();
                                            return true;
                                        });
                                    });
                                }

                                return true;
                            });
                        });
                        */
                    }
                });
            }
        }

        // ATTACH 2
        function getListAttach(sourceUID, sourceId, tSourceCode) {
            if (!sourceId) return;
            vm.list_ATT = [];
            return datacontext.attach_getAllCND(0, 0, $routeParams.projectUID, sourceUID, sourceId, 0, tSourceCode, undefined, 0, 0, '', vm.fAttach.TAttachId, '').then(function (data_ATT) {
                vm.list.b_attach = true;
                if (!$.isNumeric(data_ATT)) vm.list_ATT = data_ATT;

                return datacontext.tAttach_getAll(0, 0, tSourceCode, 0, '', 0, '').then(function (data_TA) {
                    vm.tAttach_Needed = data_TA;

                    return datacontext.tAttachVisibility_getAll(0, 0, tSourceCode).then(function (data_TAV) {
                        var tAttVis = data_TAV;

                        vm.tAttach_Needed.forEach(function (item_TA) {
                            var att = {};
                            att.TAttachId = item_TA.Id;
                            att.TAttach = item_TA.Name;

                            if (typeof (vm.list_ATT) == 'undefined') vm.list_ATT = [];
                            var myrec = _.find(vm.list_ATT, { 'TAttachId': item_TA.Id });
                            var myTAV = _.find(tAttVis, { 'TAttachId': item_TA.Id });

                            if (typeof (myTAV) == 'undefined') {
                                myTAV = {};
                                myTAV.bRead = true;
                                myTAV.bInsert = true;
                                myTAV.bUpdate = true;
                                myTAV.bDelete = true;
                                myTAV.iTags = 0;
                            }

                            att.bRead = myTAV.bRead;
                            att.bInsert = myTAV.bInsert;
                            att.bUpdate = myTAV.bUpdate;
                            att.bDelete = myTAV.bDelete;
                            att.iTags = myTAV.iTags;

                            if (typeof (myrec) == 'undefined') {
                                if (att.bRead)
                                    vm.list_ATT.push(att);
                            }
                            else {
                                myrec.bRead = myTAV.bRead;
                                myrec.bInsert = myTAV.bInsert;
                                myrec.bUpdate = myTAV.bUpdate;
                                myrec.bDelete = myTAV.bDelete;
                                myrec.iTags = myTAV.iTags;

                                var items = _.groupBy(vm.list_ATT, { 'TAttachId': item_TA.Id });

                                items.true.forEach(function (i) {
                                    i.bRead = myTAV.bRead;
                                    i.bInsert = myTAV.bInsert;
                                    i.bUpdate = myTAV.bUpdate;
                                    i.bDelete = myTAV.bDelete;
                                    i.iTags = myTAV.iTags;
                                });

                                if (myrec.bInsert) {
                                    if (item_TA.MaxValue == 99 || item_TA.MaxValue > items.true.length)
                                        vm.list_ATT.push(att);
                                }
                            }
                        });
                        //console.info('vm.list_ATT', vm.list_ATT);
                        return vm.list_ATT;
                    });
                });

                
            });
        }

        function getTAttachNeeded(code) {
            if (!code) return;
            return datacontext.tAttach_getAll(0, 0, code, 0, '', 0, '').then(function (data) {

                return vm.tAttach_Needed = data;
            });
        }

        function getTSourceACCR() {
            return datacontext.tSource_getByCode(vm.tSourceCode_ACCR).then(function (data) {
                return vm.tSource_ACCR = data;
            });
        }
        function getTSourceADES() {
            return datacontext.tSource_getByCode(vm.tSourceCode_ADES).then(function (data) {
                return vm.tSource_ADES = data;
            });
        }


        function getTAttachNeededAccr() {
            if (vm.tAttach_ACCR.length > 0) return;
            return datacontext.tAttach_getAll(0, 0, vm.tSourceCode_ACCR, 0, '', 0, '').then(function (data) {
                //console.info('getTAttachNeededAccr', data);
                return vm.tAttach_ACCR = data;
            });
        }
        function getTAttachNeededAdes() {
            if (vm.tAttach_ADES.length > 0) return;
            return datacontext.tAttach_getAll(0, 0, vm.tSourceCode_ADES, 0, '', 0, '').then(function (data) {
                //console.info('getTAttachNeededAdes', data);
                return vm.tAttach_ADES = data;
            });
        }

        function deleteAttach(item, value) {
            if (item == undefined || value == undefined || value == 0) return;

            var listATT = [];
            var tSourceCode = '';
            switch (parseInt(value)) {
                case 1:
                    listATT = vm.list.attach_accr;
                    tSourceCode = vm.tSourceCode_ACCR;
                    break;
                case 2:
                    listATT = vm.list.attach_tir1;
                    tSourceCode = vm.tSourceCode_ADES;
                    break;
                case 3:
                    listATT = vm.list.attach_tir2;
                    tSourceCode = vm.tSourceCode_ADES;
                    break;
            }

            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError('Attenzione: allegato non cancellabile! Contattare l\'Help-desk');

                    //Popolo l'oggetto att da cancellare
                    var index = listATT.indexOf(item)
                    var att = {};
                    att.TAttachId = listATT[index].TAttachId;
                    att.TAttach = listATT[index].TAttach;

                    return datacontext.tAttachVisibility_getAll(0, 0, tSourceCode).then(function (data_TAV) {
                        var tAttVis = data_TAV;

                        var myTAV = _.find(tAttVis, { 'TAttachId': att.TAttachId });

                        if (typeof (myTAV) == 'undefined') {
                            myTAV = {};
                            myTAV.bRead = true;
                            myTAV.bInsert = true;
                            myTAV.bUpdate = true;
                            myTAV.bDelete = true;
                            myTAV.iTags = 0;
                        }

                        att.bRead = myTAV.bRead;
                        att.bInsert = myTAV.bInsert;
                        att.bUpdate = myTAV.bUpdate;
                        att.bDelete = myTAV.bDelete;
                        att.iTags = myTAV.iTags;

                        vm.tAttach_Needed = [];
                        switch (tSourceCode) {
                            case 'ADES':
                                vm.tAttach_Needed = vm.tAttach_ADES;
                                break;
                            case 'ACCR':
                                vm.tAttach_Needed = vm.tAttach_ACCR;
                                break;
                        }

                        //Individuo la tipologia corrispondente
                        var item_TA = _.find(vm.tAttach_Needed, { 'Id': att.TAttachId });
                        //Raggruppo la lista per tipologia
                        var items = _.groupBy(listATT, { 'TAttachId': att.TAttachId });

                        //Se ho un allegato per la tipologia
                        if (items.true.length == 1 || item_TA.MaxValue == items.true.length) {
                            listATT[index] = att; //Ripulisco il record
                        }
                        else if (item_TA.MaxValue > items.true.length) {
                            //Rimuovo l'oggetto
                            listATT.splice(index, 1);
                        }
                    });
                });
            });
        }

        function getExtractCADESFile(id) {
            return datacontext.attach_extract(id).then(function (data) {
                if (data == "ERR01") return logError("Errore: il documento non \xE8 un documento 'P7M-CADES' valido. ");
                if (data == "ERR02") return logError("Errore: documento non trovato. ");
                if (data == "ERR03") return logError("Errore: il documento non ha firma digitale. ");

                var url = data;
                window.open(url, 'Download');
            });
        }

        function getExtractVerifySignInfo(id) {
            var fileName = "";
            return datacontext.attach_extractDigitalSignInfo(id).then(function (data) {
                fileName = data;

                if (data) {
                    common.$http.get('/api/pdf/GetVerifySign?id=' + id, { responseType: 'arraybuffer' })
                        .then(function (response) {
                            if (response.status == 204) {

                                logError('Il documento non ha Firma Digitale');
                                return;
                            }

                            var a = document.createElement("a");
                            a.setAttribute('style', 'display:none');
                            document.body.appendChild(a);
                            var file = new Blob([response.data], { type: 'application/pdf' });
                            var fileURL = URL.createObjectURL(file);
                            a.href = fileURL;
                            fileName = fileName.substring(0, fileName.indexOf('.'));

                            if ($rootScope.detectIE())
                                window.navigator.msSaveBlob(file, 'VerificaFirma_' + fileName + '.pdf');
                            else
                                a.download = 'VerificaFirma_' + fileName + '.pdf';

                            a.click();
                            document.body.removeChild(a);
                        })
                        .catch(function (message) {
                            logError('Impossibile scaricare il file');
                        });
                }

            });

        }


        // ADD ATTACH2
        function addAttach(tAttachId, value) {
            if (value == undefined || value == 0) return;

            var recTSource = {};
            var recSource = {};
            var recTSourceRefId = 0;
            var recSourceRefId = 0;
            switch (parseInt(value)) {
                case 1:
                    if (vm.record != undefined && vm.record.Id != undefined && vm.record.Id != 0) {
                        recTSource = { Id: vm.tSource_ACCR.Id, Name: vm.tSource_ACCR.Name };
                        recSource = { Id: vm.record.Id, Name: vm.accr_ref };

                        var modalInstance = modal.open({
                            templateUrl: '/app/attach/modal/attachAdd2.html?version=19',
                            controller: 'attachAdd2',
                            resolve: {
                                tSource: function () {
                                    return [recTSource];
                                },
                                tSourceCode: function () {
                                    return vm.tSource_ACCR.Code;
                                },
                                tSourceId: function () {
                                    return vm.tSource_ACCR.Id;
                                },
                                source: function () {
                                    return [recSource];
                                },
                                sourceId: function () {
                                    return recSource.Id;
                                },
                                tAttach: function () {
                                    return vm.tAttach_ACCR;
                                },
                                tAttachId: function () {
                                    return tAttachId;
                                },
                                tSourceRefId: function () {
                                    return null;
                                },
                                sourceRefId: function () {
                                    return null;
                                }
                            }
                        });

                        modalInstance.result.then(function (returnItem) {
                            if (returnItem == "406") return logError('Errore: tipologia di allegato non permessa! ');
                            if (returnItem == "400") return logError('Errore registrazione dati');

                            logSuccess('Dato salvato con successo! ');
                            populateAttach();
                        }, function () {
                            //log('Modal dismissed at: ' + new Date());
                        });

                        return true;
                    } else return;
                    //break;
                case 2:
                    if (vm.record != undefined && vm.record.Adesioni != undefined && vm.record.Adesioni.length > 0) {
                        recTSource = { Id: vm.tSource_ADES.Id, Name: vm.tSource_ADES.Name };
                        recSource = { Id: vm.record.Adesioni[0].Id, Name: vm.tir1_ref };

                        var modalInstance2 = modal.open({
                            templateUrl: '/app/attach/modal/attachAdd2.html?version=19',
                            controller: 'attachAdd2',
                            resolve: {
                                tSource: function () {
                                    return [recTSource];
                                },
                                tSourceCode: function () {
                                    return vm.tSource_ADES.Code;
                                },
                                tSourceId: function () {
                                    return vm.tSource_ADES.Id;
                                },
                                source: function () {
                                    return [recSource];
                                },
                                sourceId: function () {
                                    return recSource.Id;
                                },
                                tAttach: function () {
                                    return vm.tAttach_ADES;
                                },
                                tAttachId: function () {
                                    return tAttachId;
                                },
                                tSourceRefId: function () {
                                    return vm.tSource_ACCR.Id;
                                },
                                sourceRefId: function () {
                                    return vm.record.Id;
                                }
                            }
                        });

                        modalInstance2.result.then(function (returnItem) {
                            if (returnItem == "406") return logError('Errore: tipologia di allegato non permessa! ');
                            if (returnItem == "400") return logError('Errore registrazione dati');

                            logSuccess('Dato salvato con successo! ');
                            populateAttach();
                        }, function () {
                            //log('Modal dismissed at: ' + new Date());
                        });

                        return true;
                    } else return;
                    //break;
                case 3:
                    if (vm.record != undefined && vm.record.Adesioni != undefined && vm.record.Adesioni.length > 1) {
                        recTSource = { Id: vm.tSource_ADES.Id, Name: vm.tSource_ADES.Name };
                        recSource = { Id: vm.record.Adesioni[1].Id, Name: vm.tir2_ref };

                        var modalInstance3 = modal.open({
                            templateUrl: '/app/attach/modal/attachAdd2.html?version=19',
                            controller: 'attachAdd2',
                            resolve: {
                                tSource: function () {
                                    return [recTSource];
                                },
                                tSourceCode: function () {
                                    return vm.tSource_ADES.Code;
                                },
                                tSourceId: function () {
                                    return vm.tSource_ADES.Id;
                                },
                                source: function () {
                                    return [recSource];
                                },
                                sourceId: function () {
                                    return recSource.Id;
                                },
                                tAttach: function () {
                                    return vm.tAttach_ADES;
                                },
                                tAttachId: function () {
                                    return tAttachId;
                                },
                                tSourceRefId: function () {
                                    return vm.tSource_ACCR.Id;
                                },
                                sourceRefId: function () {
                                    return vm.record.Id;
                                }
                            }
                        });

                        modalInstance3.result.then(function (returnItem) {
                            if (returnItem == "406") return logError('Errore: tipologia di allegato non permessa! ');
                            if (returnItem == "400") return logError('Errore registrazione dati');

                            logSuccess('Dato salvato con successo! ');
                            populateAttach();
                        }, function () {
                            //log('Modal dismissed at: ' + new Date());
                        });

                        return true;
                    } else return;
                    //break;
            }
        };


        //*****************************************************
        //Elenchi Parametri

        function getTSource(code) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }

        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }


        function getProfili() {
            datacontext.arrProfili().then(function (data) {
                vm.profili = data;
            });
        }

        function getTFormaGiuridica() {
            if (vm.lstFormaGiuridica.length > 0) return;

            datacontext.arrFormaGiuridica().then(function (data) {
                vm.lstFormaGiuridica = data;
            });
        }

        function getProvince() {
            if (vm.province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.province = data;
            });
        }

        function getProvinceSicilia(regioneId) {
            if (vm.provinceSicilia.length > 0) return;

            datacontext.arrProvinceByReg(regioneId).then(function (data) {
                vm.provinceSicilia = data;
            });
        }

        function resetComuni(idprov) {
            vm.record.ComuneId = 0;
            getComuni(idprov);
        }
        function getComuni(idprov) {
            if (!idprov || idprov == 0) {
                return vm.comuni = [];
            }

            if (vm.record.ProvinciaId != idprov)
                vm.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.comuni = data;
            });
        }

        function getPaesi_Nasc() {
            if (vm.paesiNasc_L.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.paesiNasc_L = data;
            });
        }

        function getProvince_Nasc() {
            if (vm.provinceNasc_L.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.provinceNasc_L = data;
            });
        }

        function resetComuniNasc(idprov) {
            vm.record.L_ComuneNascId = 0;
            getComuniNasc(idprov);
        }

        function getComuniNasc(idprov) {
            if (!idprov || idprov == 0) {
                return vm.comuniNasc_L = [];
            }

            if (vm.record.L_ProvNascId != idprov)
                vm.comuniNasc_L = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.comuniNasc_L = data;
            });
        }



        //Metodi interfaccia Filtri
        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }

        //*************************************
        //cndAccreditamenti SEDI
        function getAllCNDAccreditamentiSedi(cndProgettoId, cndAccreditamentoId) {
            vm.list.cndAccreditamentiSedi = [];
            return datacontext.cndAccreditamentoSede_getAll(0, 0, '', cndProgettoId, cndAccreditamentoId, 0, 0, '').then(function (data) {
                return vm.list.cndAccreditamentiSedi = data;
            });
        }

        function cndAccreditamentoSede_exists(cndAccreditamentoId, provinciaId, comuneId) {
            return datacontext.cndAccreditamentoSede_exists(cndAccreditamentoId, provinciaId, comuneId).then(function (data) {
                return data;
            });
        }



        function addCNDAccreditamentoSedeRecord(id) {
            return datacontext.cndAccreditamentoSede_get(id).then(function (data) {
                vm.list.cndAccreditamentiSedi.push(data);
            });
        }

        function loadCNDAccreditamentoSedeRecord(index, item) {
            vm.list.cndAccreditamentiSedi[index].Ref_Cognome = item.Ref_Cognome;
            vm.list.cndAccreditamentiSedi[index].Ref_Nome = item.Ref_Nome;
            vm.list.cndAccreditamentiSedi[index].Indirizzo = item.Indirizzo;
            vm.list.cndAccreditamentiSedi[index].Cap = item.Cap;
            vm.list.cndAccreditamentiSedi[index].Comune = item.Comune;
            vm.list.cndAccreditamentiSedi[index].Telefono = item.Telefono;
            vm.list.cndAccreditamentiSedi[index].Email = item.Email;
        }

        function deleteCNDAccreditamentoSede(item) {
            var msg = ' la sede : ' + item.Provincia;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.cndAccreditamentoSede_delete(item.Id).then(function (data) {
                    if (data == "404") return logError('Errore cancellazione dati');

                    var index = vm.list.cndAccreditamentiSedi.indexOf(item)
                    vm.list.cndAccreditamentiSedi.splice(index, 1);
                });
            });
        }



        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************

        //Modal - cndAccreditamento Sede
        function addCNDAccreditamentoSede() {
            var modalInstance = modal.open({
                templateUrl: '/app/CND_Accreditamento/modal/cndAccreditamentoSedeAdd.html?version=19',
                controller: 'cndAccreditamentoSedeAdd',
                resolve: {
                    cndAccredSede: function () {
                        return null;
                    },
                    province: function () {
                        return vm.province;
                    },
                    cndAccreditamentoId: function () {
                        return vm.record.Id;
                    },
                    progettoId: function () {
                        return vm.record.ProgettoId;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "400") return logError('Errore di crezione! ');

                logSuccess('Dato salvato con successo! ');
                addCNDAccreditamentoSedeRecord(returnItem.Id);
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        function editCNDAccreditamentoSede(index, objSede) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND_Accreditamento/modal/cndAccreditamentoSedeAdd.html?version=19',
                controller: 'cndAccreditamentoSedeAdd',
                resolve: {
                    cndAccredSede: function () {
                        return objSede;
                    },
                    province: function () {
                        return vm.province;
                    },
                    cndAccreditamentoId: function () {
                        return vm.record.Id;
                    },
                    progettoId: function () {
                        return vm.record.ProgettoId;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "400") return logError('Errore di crezione! ');

                logSuccess('Dato modificato con successo! ');
                loadCNDAccreditamentoSedeRecord(index, returnItem);
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };
        //************************END*****************************



        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-SUGGESTION PER CODICE ATECO-#-#-#-#-#-#

        //Define Suggestions List
        vm.validAteco = false;
        vm.suggestionsAteco = [];
        vm.suggestionsObjAteco = [];
        //Define Selected Suggestion Item
        vm.selectedIndexAteco = -1;

        //Function To Call On ng-change
        vm.searchAteco = function () {
            //console.log('searchAteco()');
            vm.suggestionsAteco = [];
            vm.suggestionsObjAteco = [];
            var myMaxSuggestionListLength = 0;
            if (vm.record.searchTextAteco == undefined) return;
            if (vm.record.searchTextAteco.length < 2) return; //numero minimo di caratteri

            return datacontext.tAteco_getByText(vm.record.searchTextAteco).then(function (data) {
                //console.log(data);
                if (data) {
                    vm.suggestionsAteco = [];
                    vm.suggestionsObjAteco = data;
                    data.forEach(function (item) {
                        vm.suggestionsAteco.push(item.Name);
                    });
                }
            });
        }

        //Keep Track Of Search Text Value During The Selection From The Suggestions List  
        $scope.$watch('selectedIndexAteco', function (val) {
            if (val !== -1 && typeof (val) != 'undefined') {
                vm.record.searchTextAteco = vm.suggestionsAteco[vm.selectedIndexAteco];
                vm.record.TAtecoId = vm.suggestionsObjAteco[vm.selectedIndexAteco].Id;
                vm.validAteco = true;
            }
        });


        //Text Field Events
        //Function To Call on ng-keydown
        vm.checkKeyDownAteco = function (event) {
            if (event.keyCode === 40) {//down key, increment selectedIndexAteco
                event.preventDefault();
                if (vm.selectedIndexAteco + 1 !== vm.suggestionsAteco.length) {
                    vm.selectedIndexAteco++;
                }
            } else if (event.keyCode === 38) { //up key, decrement selectedIndexAteco
                event.preventDefault();
                if (vm.selectedIndexAteco - 1 !== -1) {
                    vm.selectedIndexAteco--;
                }
            } else if (event.keyCode === 13) { //enter key, empty suggestions array
                event.preventDefault();
                vm.suggestionsAteco = [];
                vm.suggestionsObjAteco = [];
            }
        }
        //Function To Call on ng-keyup
        vm.checkKeyUpAteco = function (event) {
            if (event.keyCode !== 8 && event.keyCode !== 46) {//delete or backspace     			
                if (vm.record.searchTextAteco == "") {
                    vm.suggestionsAteco = [];
                    vm.suggestionsObjAteco = [];
                }
            } else {
                if (vm.record.TAtecoId > 0) {
                    vm.record.TAtecoId = 0;
                    vm.validAteco = false;
                    vm.record.searchTextAteco = '';
                }
            }
        }
        //======================================

        //List Item Events
        //Function To Call on ng-click
        vm.AssignValueAndHideAteco = function (index) {
            //console.log('hide');
            vm.record.searchTextAteco = vm.suggestionsAteco[index];
            vm.record.TAtecoId = vm.suggestionsObjAteco[index].Id;
            vm.validAteco = true;
            vm.suggestionsAteco = [];
            vm.suggestionsObjAteco = [];
        }
        //======================================

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS LIBERO PROF FOR CF -#-#-#-#-#-#
        vm.existsL_CF = false;
        vm.searchL_CF = function (value) {
            vm.existsL_CF = false;
            if (value == undefined) return;
            if (value.length != 16) return; //numero minimo di caratteri            
            return datacontext.cndAccreditamento_exists(vm.record.Id, value, '', '', '', false, vm.record.ProgettoId).then(function (data) {
                vm.existsL_CF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS AZIENDA FOR CF -#-#-#-#-#-#
        vm.existsCF = false;
        vm.searchCF = function (value) {
            vm.existsCF = false;
            if (value == undefined) return;
            if (value.length != 11 && value.length != 16) return; //numero minimo di caratteri            
            return datacontext.cndAccreditamento_exists(vm.record.Id, '', '', value, '', true, vm.record.ProgettoId).then(function (data) {
                vm.existsCF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS AZIENDA FOR PIVA -#-#-#-#-#-#
        vm.existsPIVA = false;
        vm.searchPIVA = function (value) {
            vm.existsPIVA = false;
            if (value == undefined) return;
            if (value.length != 11) return; //numero minimo di caratteri            
            return datacontext.cndAccreditamento_exists(vm.record.Id, '', '', '', value, true, vm.record.ProgettoId).then(function (data) {
                vm.existsPIVA = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID PARTITA IVA -#-#-#-#-#-#
        vm.validPIVA = true;
        vm.getValidPIVA = function (value) {
            vm.validPIVA = false;
            if (value == undefined) return;
            if (value.length != 11) return; //numero minimo di caratteri            
            return datacontext.validazione_piva(value, false).then(function (data) {
                return vm.validPIVA = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        vm.validCF = true;
        vm.getValidCF = function (value) {
            vm.validCF = false;
            if (value == undefined) return;
            if (value.length != 16) return; //numero minimo di caratteri            
            return datacontext.validazione_cf(value).then(function (data) {
                return vm.validCF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID FIELDS CODICE FISCALE -#-#-#-#-#-#
        vm.validFieldsCF = true;
        vm.getValidFieldsCF = function () {
            vm.validFieldsCF = vm.record.L_CodiceFiscale != undefined && vm.record.L_CodiceFiscale.length > 10 ? false : true;
            if (vm.record.L_CodiceFiscale == undefined) return;
            if (vm.record.L_CodiceFiscale.length != 16) return; //numero minimo di caratteri
            if (vm.record.L_Nome == undefined) return;
            if (vm.record.L_Cognome == undefined) return;
            if (vm.record.L_Sesso == undefined) return;
            if (vm.record.L_PaeseNascId == 0 && (vm.record.L_ComuneNascId == undefined || vm.record.L_ComuneNascId == 0)) return;
            if (vm.record.L_DtNasc == undefined || vm.record.L_DtNasc == '') return;
            var strDtNasc = common.dateToString(vm.record.L_DtNasc); //la data deve avere formato dd/MM/yyyy            
            return datacontext.validazione_fieldsCF(vm.record.L_CodiceFiscale, vm.record.L_Nome, vm.record.L_Cognome, vm.record.L_Sesso, strDtNasc, vm.record.L_PaeseNascId, vm.record.L_ComuneNascId).then(function (data) {
                return vm.validFieldsCF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID FIELDS CODICE FISCALE - TIROCINANTE -#-#-#-#-#-#
        vm.validFieldsCFTir = true;
        vm.getValidFieldsCFTir = function () {
            var numChar = 16;
            vm.validFieldsCFTir = vm.adesione.CodiceFiscale != undefined && vm.adesione.CodiceFiscale.length > 10 ? false : true;
            if (vm.adesione.CodiceFiscale == undefined) return;
            if (vm.adesione.NascPaeseId == 0 && vm.adesione.CittadinanzaId == 0 && vm.adesione.CodiceFiscale.length != numChar) return; //numero minimo di caratteri
            if (vm.adesione.Nome == undefined) return;
            if (vm.adesione.Cognome == undefined) return;
            if (vm.adesione.Sesso == undefined) return;
            if (vm.adesione.NascPaeseId == 0 && (vm.adesione.NascComuneId == undefined || vm.adesione.NascComuneId == 0)) return;
            if (vm.adesione.NascData == undefined || vm.adesione.NascData == '') return;
            var strDtNasc = common.dateToString(vm.adesione.NascData); //la data deve avere formato dd/MM/yyyy            
            return datacontext.validazione_fieldsCF(vm.adesione.CodiceFiscale, vm.adesione.Nome, vm.adesione.Cognome, vm.adesione.Sesso, strDtNasc, vm.adesione.NascPaeseId, vm.adesione.NascComuneId, vm.adesione.IsForeignCF).then(function (data) {
                return vm.validFieldsCFTir = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID IBAN -#-#-#-#-#-#
        vm.validIBAN = true;
        vm.getValidIBAN = function (value) {
            vm.validIBAN = false;
            if (value == undefined) return;
            if (value.length != 27) return; //numero minimo di caratteri            
            return datacontext.validazione_iban(value).then(function (data) {
                return vm.validIBAN = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-SUGGESTION PER CODICE ATECO-#-#-#-#-#-#

        //Define Suggestions List
        vm.suggestionsAteco = [];
        vm.suggestionsObjAteco = [];
        //Define Selected Suggestion Item
        vm.selectedIndexAteco = -1;

        //Function To Call On ng-change
        vm.searchAteco = function () {
            console.log('searchAteco()');
            vm.suggestionsAteco = [];
            vm.suggestionsObjAteco = [];
            if (vm.record.searchTextAteco == undefined) return;
            if (vm.record.searchTextAteco.length < 3) return; //numero minimo di caratteri

            return datacontext.tAteco_getByText(vm.record.searchTextAteco).then(function (data) {
                console.log(data);
                if (data) {
                    vm.suggestionsAteco = [];
                    vm.suggestionsObjAteco = data;
                    data.forEach(function (item) {
                        vm.suggestionsAteco.push(item.Name);
                    });
                }
            });
        };

        //Keep Track Of Search Text Value During The Selection From The Suggestions List  
        $scope.$watch('selectedIndexAteco', function (val) {
            console.log('$watch Ateco');
            if (val !== -1 && typeof (val) != 'undefined') {
                vm.record.searchTextAteco = vm.suggestionsAteco[vm.selectedIndexAteco];
                vm.record.TAtecoId = vm.suggestionsObjAteco[vm.selectedIndexAteco].Id;
            }
        });


        //Text Field Events
        //Function To Call on ng-keydown
        vm.checkKeyDownAteco = function (event) {
            if (event.keyCode === 40) {//down key, increment selectedIndexAteco
                event.preventDefault();
                if (vm.selectedIndexAteco + 1 !== vm.suggestionsAteco.length) {
                    vm.selectedIndexAteco++;
                }
            } else if (event.keyCode === 38) { //up key, decrement selectedIndexAteco
                event.preventDefault();
                if (vm.selectedIndexAteco - 1 !== -1) {
                    vm.selectedIndexAteco--;
                }
            } else if (event.keyCode === 13) { //enter key, empty suggestions array
                event.preventDefault();
                vm.suggestionsAteco = [];
                vm.suggestionsObjAteco = [];
            }
        };
        //Function To Call on ng-keyup
        vm.checkKeyUpAteco = function (event) {
            if (event.keyCode !== 8 && event.keyCode !== 46) {//delete or backspace     			
                if (vm.record.searchTextAteco == "") {
                    vm.suggestionsAteco = [];
                    vm.suggestionsObjAteco = [];
                }
            } else {
                if (vm.record.TAtecoId > 0) {
                    vm.record.TAtecoId = '';
                    vm.record.searchTextAteco = '';
                }
            }
        };
        //======================================

        //List Item Events
        //Function To Call on ng-click
        vm.AssignValueAndHideAteco = function (index) {
            console.log('hide');
            vm.record.searchTextAteco = vm.suggestionsAteco[index];
            vm.record.TAtecoId = vm.suggestionsObjAteco[index].Id;
            vm.suggestionsAteco = [];
            vm.suggestionsObjAteco = [];
        };
		//======================================



    }
})();
